export default {
  en: {
    aboutMeTitle:
      "IUX Markets started to raise the level of trading to a high level of security. Swift executions with world’s best technology in the CFDs market. We have observed numerous issues with trading and have taken action to fix them; to allow customers to be able to access the trading system and conduct various transactions quickly and safely. We also value Commodities at all times from devoting time and understanding the importance of the world of financial markets that fluctuate quickly and efficiently. Every decision we make is to ensure that our customers and business partners, including our team of experts, spend time wisely. We believe that knowledge is power and encouraging traders to get the best investment results is our desire.",
    aboutMeIcon: {
      title_1: "World Class Safety Standards",
      description_1:
        "We keep your data safe and secure with encryption and 24/7 surveillance.",
      title_2: "Fast transactions are our priority. \n",
      description_2:
        "We truly understand the experience of traders that is why we make everything simple.",
      title_3: "High-Speed Execution",
      description_3:
        "We want our clients to have the best trading experience. With this level of speed, you will not miss the opportunity.",
      title_4: "We partner with banks around the world.\n",
      description_4:
        "We cooperate with domestic and foreign banks. Allowing you to receive bonus credits from depositing funds to minimize the risk as much as possible.",
    },
    accept_policy: `Accept the terms and conditions`,
    policy_dashboard_1: `Dear Customers,\n\nThis only has an impact on stocks. Please note of the following updates if you trade stocks (CFDs).\n\nTrading by setting pending orders before the market opens is not possible.\n\nThe order will be invalidated or canceled.Only once the market opens can active orders be placed.As a result, group financial instruments are covered all Stocks (CFDs).\n\nPlease consider this information and make adjustments to your trading strategy in advance if necessary!\n\nBest Regards, IUX Markets Limited.`,
    accountType: {
      standard: `Top accounts with lowest spread No commissions Suitable for all types of trading For investors of all levels , No deposit and withdrawal fees`,
      list: {
        list_1: `Spread from 0.2 PIPs`,
        list_2: `Max Leverage 1:3000`,
        list_3: `No Commission`,
        list_4: `Minimum deposit 10 USD`,
      },
      cent: `An account for beginner investors with fewer investment units Suitable for all types of trading `,
      list_cent: {
        list_1: `Spread from 0.2 PIPs`,
        list_2: `Max Leverage 1:3000`,
        list_3: `No Commission`,
        list_4: `Minimum deposit 10 USD`,
      },
      standard_bonus: `35% bonus account suitable for long term trading. No fees , No deposit and withdrawal fees`,
      list_bonus: {
        list_1: `Spread from 0.5 PIPs`,
        list_2: `Max Leverage 1:1000`,
        list_3: `35% Deposit Bonus`,
        list_4: `Minimum deposit 10 USD`,
      },
      standard_ecn: `VIP Investor account spread start from 0.0 PIPs, commission is just $ 3.5 only, No deposit and withdrawal fees`,
      list_ecn: {
        list_1: `Spread from 0.0 PIPs`,
        list_2: `Max Leverage 1:3000`,
        list_3: `$3.5 Commission`,
        list_4: `Minimum deposit 200 USD`,
      },
      standard_raw: `VIP Investor account spread start from 0.0 PIPs, commission is just $ 7 only, No deposit and withdrawal fees`,
      list_raw: {
        list_1: `Spread from 0.0 PIPs`,
        list_2: `Max Leverage 1:3000`,
        list_3: `$6 Commission`,
        list_4: `Minimum deposit 200 USD`,
      },
      standard_pro: `Trade with the lowest spread Excellent fill and reduced slippage. Requotes may happen in fast-moving markets`,
      list_pro: {
        list_1: `Spread 0.1 PIPs`,
        list_2: `No Commission`,
        list_3: `Minimum Deposit 1000 USD`,
        list_4: `0.1 Minimum  Lot size`,
      },
      btn: {
        real: `Open a real trading account`,
        demo: `Trading on a demo account`,
      },
    },

    aboutPage: {
      why_become: "WHY BECOME OUR PARTNER??",
      Our_in_house:
        "Our in-house spot aggregator and advanced order-matching technology provide our traders with access to a deep liquidity pool and ultra-fast trade execution with no dealing desk intervention so that traders can benefit from tight Spread and competitive pricing.",
      our_history: {
        header: "OUR HISTORY",
        detail:
          "Ever since our establishment, IUX Markets has successfully expanded to serve retail and institutional clients in more than 170 countries - and we are still growing.",
        title_2:
          "IUX Markets Limited. Which is subject to supervision by the Securities Commission. Financial Services Authority Has allowed the business of financial services and number  T2023172 Registered Address:P.B. 1257 Bonovo Road, Fomboni, Comoros, KM. and the Grenadines and IUX Markets Limited. also registered with the National Futures Association (NFA) from United States which designated by the CFTC as a registered futures association. NFA strives everyday to safeguard the integrity of the derivatives markets, protect investors and ensure members meet their regulatory responsibilities.",
      },
      box_1: {
        des_1: `IUX Markets offers trading on Shares, Spot Indices, Futures, Spot Metals and Spot Energies. We provide our clients with access to top-tier liquidity and advanced trade execution with no dealing desk intervention.`,
      },
      box_2: {
        des_1: `IUX Markets Limited, which is subject to supervision by the Securities Commission. Financial Services Authority in Saint Vincent and the Grenadines has allowed the business of financial services and number `,
        // des_2: `registered at Beachmont Business Centre, 321, Kingstown, St. Vincent and the Grenadines and IUX Markets Limited also registered with MWALI International Services Authority (Comoros) as a regulated and licensed broker of international CFDs trading securities with license number`,
        des_2: `registered at Beachmont Business Centre, 321, Kingstown, St. Vincent and the Grenadines`,
        des_3: `IUX Markets Limited is registered with the National Futures Association (NFA) trading regulator, which supervises derivatives and futures brokers,`,
      },
      section_1: {
        title_1: `Company History`,
        description_1: `IUX Markets was established  in 2016 as a provider of online CFDs trading services. Our client’s trading journey is very important to us, and as such we are always committed in refining our technology, tailored services and client education. For over a decade, as the industry and clients’ expectations keep evolving, we have positioned ourselves firmly as a trusted and leading  regulated broker.`,
        title_2: `Our Services`,
        description_2: `IUX Markets currently offers a spread-based and a commission-based trading account. We have more than 350 tradeable CFDs instruments including CFDs, Shares, Indices and Commodities. Widely recognised as the first MT4 broker in United Kingdom, we have since added MT4,mobile trading and a web-based platform to our suite of trading platforms.`,
        title_3: `Our Vision`,
        description_3: `We strive to be the first choice for trading CFDs for aspiring and experienced traders. We strive to continuously provide the best trading experience to our clients through reliable customer service, transparent pricing, low-latency trade execution and platform stability.`,
        description_4: `We are committed to creating a dynamic
                    environment that equips traders with all the necessary tools
                    for their trading experience with the utmost respect for
                    them.`,
        title_5: `Our Strategy`,
        description_5: `At IUXMARKETS we evolve with the times. We aim to continuously refine our services to cater to the needs of traders in this highly dynamic industry.`,
      },
      section_2: {
        title: `Our Values`,
        title_1: `Client-first approach`,
        title_2: `Integrity and Compliance`,
        title_3: `Innovation`,
        description_1: `We strive to be the first choice for trading CFDs for aspiring and experienced traders. We strive to continuously provide the best trading experience to our clients through reliable customer service, transparent pricing, low-latency trade execution and platform stability.`,
        description_2: `We endeavour to provide clients with transparent, secure and reliable services. IUX Markets is licensed by the St-Vincent CFDs Broker License `,
        description_3: `IUX Markets is dedicated to ensuring fast execution speed, quality trading platforms and secure transactions as a minimum standard for your trading experience.`,
      },
      section_3: {
        title: `Regulation`,
        description: `IUX Markets is regulated by the St-Vincent CFDs Broker License  and is a holder of an Investment Dealer (Discount Broker)`,
        sub_head_title_1: `Locations`,
        title_1: `United Kingdom`,
        title_2: ``,
        title_3: `Singapore`,
        description_1: `6-8 Revenge Road , Suite 2096 United Kingdom \nME5 8UD Chatham, UK support@iuxmarket.com`,
        description_2: `P.B. 1257 Bonovo Road, Fomboni, Comoros, KM. `,
        description_3: `30 Paya Lebar Road, #01-37, Paya Lebar Square, \nSingapore 409051 `,
      },
    },
  },
  pt: {
    aboutMeTitle:
      "A IUX Markets passou a elevar o nível de trading para um padrão máximo de segurança. Execuções rápidas com a melhor tecnologia do mundo no mercado de CFDs. Observámos inúmeros problemas na negociação e agimos para corrigi-los, permitindo que os clientes acedam ao sistema de trading e efetuem várias transações com rapidez e segurança. Valorizamos igualmente as Commodities, dedicando tempo e compreendendo a importância dos mercados financeiros que oscilam de forma rápida e eficiente. Cada decisão que tomamos visa garantir que os nossos clientes, parceiros de negócio e equipa de especialistas utilizem o seu tempo de forma inteligente. Acreditamos que conhecimento é poder e incentivar os traders a obter os melhores resultados de investimento é o nosso objetivo.",
    aboutMeIcon: {
      title_1: "Padrões de Segurança de Classe Mundial",
      description_1:
        "Mantemos os seus dados seguros com encriptação e vigilância 24/7.",
      title_2: "Transações rápidas são a nossa prioridade.\n",
      description_2:
        "Compreendemos verdadeiramente a experiência do trader e, por isso, simplificamos tudo.",
      title_3: "Execução em Alta Velocidade",
      description_3:
        "Queremos que os nossos clientes tenham a melhor experiência de trading. Com esta velocidade, você não perderá oportunidades.",
      title_4: "Parceria com bancos em todo o mundo.\n",
      description_4:
        "Cooperamos com bancos nacionais e estrangeiros, permitindo-lhe receber bónus de crédito ao depositar fundos e assim reduzir o risco ao máximo.",
    },
    accept_policy: `Aceitar os termos e condições`,
    policy_dashboard_1: `Caro(a) Cliente,\n\nIsto afeta apenas as ações. Caso negoceie ações (CFDs), tome nota das seguintes atualizações.\n\nNão é possível colocar ordens pendentes antes da abertura do mercado.\n\nA ordem será invalidada ou cancelada. Só quando o mercado abrir é que as ordens ativas podem ser colocadas. Como resultado, todos os instrumentos do grupo abrangem Ações (CFDs).\n\nConsidere esta informação e ajuste a sua estratégia de trading com antecedência, se necessário!\n\nAtenciosamente, IUX Markets Limited.`,
    accountType: {
      standard: `Contas premium com o spread mais baixo, sem comissões. Adequadas para todos os tipos de trading e níveis de investidor, sem taxas de depósito e saque`,
      list: {
        list_1: `Spread a partir de 0,2 PIPs`,
        list_2: `Alavancagem máxima 1:3000`,
        list_3: `Sem comissão`,
        list_4: `Depósito mínimo de 10 USD`,
      },
      cent: `Conta para investidores iniciantes, com unidades de investimento menores. Adequada para todos os tipos de trading`,
      list_cent: {
        list_1: `Spread a partir de 0,2 PIPs`,
        list_2: `Alavancagem máxima 1:3000`,
        list_3: `Sem comissão`,
        list_4: `Depósito mínimo de 10 USD`,
      },
      standard_bonus: `Conta com bónus de 35 % adequada a operações de longo prazo. Sem taxas de depósito e saque`,
      list_bonus: {
        list_1: `Spread a partir de 0,5 PIPs`,
        list_2: `Alavancagem máxima 1:1000`,
        list_3: `Bónus de depósito de 35 %`,
        list_4: `Depósito mínimo de 10 USD`,
      },
      standard_ecn: `Conta VIP com spread a partir de 0,0 PIPs, comissão de apenas 3,5 USD, sem taxas de depósito e saque`,
      list_ecn: {
        list_1: `Spread a partir de 0,0 PIPs`,
        list_2: `Alavancagem máxima 1:3000`,
        list_3: `Comissão de 3,5 USD`,
        list_4: `Depósito mínimo de 200 USD`,
      },
      standard_raw: `Conta VIP com spread a partir de 0,0 PIPs, comissão de apenas 7 USD, sem taxas de depósito e saque`,
      list_raw: {
        list_1: `Spread a partir de 0,0 PIPs`,
        list_2: `Alavancagem máxima 1:3000`,
        list_3: `Comissão de 6 USD`,
        list_4: `Depósito mínimo de 200 USD`,
      },
      standard_pro: `Negocie com o spread mais baixo, excelente execução e menor slippage. Requotes podem ocorrer em mercados de alta volatilidade`,
      list_pro: {
        list_1: `Spread 0,1 PIPs`,
        list_2: `Sem comissão`,
        list_3: `Depósito mínimo de 1000 USD`,
        list_4: `Tamanho mínimo de lote 0,1`,
      },
      btn: {
        real: `Abrir conta real`,
        demo: `Negociar em conta demo`,
      },
    },

    aboutPage: {
      why_become: "POR QUE SER NOSSO PARCEIRO??",
      Our_in_house:
        "O nosso agregador de preços interno e a avançada tecnologia de correspondência de ordens proporcionam aos nossos traders um profundo pool de liquidez e execução ultra-rápida sem intervenção de mesa de negociação, permitindo-lhes beneficiar de spreads reduzidos e preços competitivos.",
      our_history: {
        header: "A NOSSA HISTÓRIA",
        detail:
          "Desde a sua fundação, a IUX Markets expandiu-se com êxito para atender clientes de varejo e institucionais em mais de 170 países — e continuamos crescendo.",
        title_2:
          "A IUX Markets Limited, supervisionada pela Securities Commission. A Financial Services Authority autorizou a prestação de serviços financeiros sob o n.º T2023172. Endereço registrado: P.B. 1257 Bonovo Road, Fomboni, Comoros, KM. A IUX Markets Limited também está registrada na National Futures Association (NFA) dos Estados Unidos, designada pela CFTC como associação de futuros registrada. A NFA trabalha diariamente para salvaguardar a integridade dos mercados de derivativos, proteger os investidores e garantir que os membros cumpram as suas obrigações regulatórias.",
      },
      box_1: {
        des_1: `A IUX Markets oferece negociação em Ações, Índices à Vista, Futuros, Metais à Vista e Energias à Vista. Proporcionamos aos nossos clientes acesso a liquidez de topo e execução avançada sem intervenção de mesa de negociação.`,
      },
      box_2: {
        des_1: `A IUX Markets Limited, supervisionada pela Securities Commission. A Financial Services Authority em São Vicente e Granadinas autorizou a prestação de serviços financeiros sob o número `,
        des_2: `registrada no Beachmont Business Centre, 321, Kingstown, St. Vincent and the Grenadines`,
        des_3: `A IUX Markets Limited está registrada na National Futures Association (NFA), regulador que supervisiona corretores de derivativos e futuros,`,
      },
      section_1: {
        title_1: `Histórico da Empresa`,
        description_1: `A IUX Markets foi fundada em 2016 como provedora de serviços de negociação online de CFDs. A jornada de trading dos nossos clientes é muito importante para nós e, por isso, comprometemo-nos constantemente a aperfeiçoar a nossa tecnologia, serviços personalizados e educação do cliente. Há mais de uma década, à medida que o setor e as expectativas dos clientes evoluem, consolidámo-nos como corretora regulamentada confiável e líder.`,
        title_2: `Os Nossos Serviços`,
        description_2: `A IUX Markets oferece atualmente contas baseadas em spread e em comissão. Dispomos de mais de 350 instrumentos de CFDs, incluindo Ações, Índices e Commodities. Amplamente reconhecida como a primeira corretora MT4 no Reino Unido, adicionámos posteriormente MT4, trading móvel e uma plataforma web ao nosso conjunto de plataformas de negociação.`,
        title_3: `A Nossa Visão`,
        description_3: `Procuramos ser a primeira escolha de trading de CFDs para traders iniciantes e experientes. Trabalhamos continuamente para proporcionar a melhor experiência de trading, através de um serviço ao cliente confiável, preços transparentes, execução de baixa latência e estabilidade da plataforma.`,
        description_4: `Estamos empenhados em criar um ambiente dinâmico
                    que ofereça aos traders todas as ferramentas necessárias
                    para a melhor experiência de trading, com o máximo respeito
                    por eles.`,
        title_5: `A Nossa Estratégia`,
        description_5: `Na IUX MARKETS evoluímos com o tempo. Procuramos refinar continuamente os nossos serviços para satisfazer as necessidades dos traders neste setor altamente dinâmico.`,
      },
      section_2: {
        title: `Os Nossos Valores`,
        title_1: `Abordagem centrada no cliente`,
        title_2: `Integridade e Conformidade`,
        title_3: `Inovação`,
        description_1: `Procuramos ser a primeira escolha de trading de CFDs para traders iniciantes e experientes. Trabalhamos continuamente para proporcionar a melhor experiência de trading aos nossos clientes através de um serviço confiável, preços transparentes, execução de baixa latência e estabilidade da plataforma.`,
        description_2: `Procuramos oferecer serviços transparentes, seguros e confiáveis. A IUX Markets possui licença de Corretora de CFDs de São Vicente `,
        description_3: `A IUX Markets compromete-se a garantir execução rápida, plataformas de qualidade e transações seguras como mínimo para a sua experiência de trading.`,
      },
      section_3: {
        title: `Regulamentação`,
        description: `A IUX Markets é regulamentada pela Licença de Corretora de CFDs de São Vicente e possui licença de Investment Dealer (Discount Broker)`,
        sub_head_title_1: `Localizações`,
        title_1: `Reino Unido`,
        title_2: ``,
        title_3: `Singapura`,
        description_1: `6-8 Revenge Road, Suite 2096, United Kingdom\nME5 8UD Chatham, UK  •  support@iuxmarket.com`,
        description_2: `P.B. 1257 Bonovo Road, Fomboni, Comoros, KM.`,
        description_3: `30 Paya Lebar Road, #01-37, Paya Lebar Square,\nSingapore 409051`,
      },
    },
  },
  th: {
    aboutMeTitle:
      "IUX Markets เริ่มต้นขึ้นเพื่อยกระดับการเทรดให้มีความปลอดภัยระดับสูง ดำเนินการทุกขั้นตอนอย่างรวดเร็ว ก้าวหน้า พร้อมทั้ง เครื่องมือการเทรดที่ทันสมัยในตลาด CFDs และเราได้เล็งเห็นปัญหาการเทรดมากมายและได้ดำเนินการแก้ไขให้ดีขึ้น เพื่อให้ลูกค้า สามารถเข้าใช้ระบบการเทรดและดำเนินธุรกรรมต่าง ๆ ได้อย่าง รวดเร็ว และปลอดภัย เราให้ความสำคัญกับสินค้าโภคภัณฑ์ที่มีค่าตลอดเวลา จากการทุ่มเทเวลาและการทำความเข้าใจถึงความสำคัญของโลกแห่ง ตลาดเงินที่ผันผวนอย่างรวดเร็วและมีประสิทธิภาพ ทุกการตัดสินใจที่เราทำ มีวัตถุประสงค์เพื่อให้แน่ใจว่าลูกค้าและหุ้นส่วน ธุรกิจของเรา รวมถึงทีมงานผู้เชี่ยวชาญได้ใช้เวลาอย่างชาญฉลาด เราเชื่อว่า ความรู้คืออำนาจ และการส่งเสริมให้เทรดเดอร์ ได้รับผลจากการลงทุนที่ดีที่สุดเป็นความต้องการของเรา ",
    aboutMeIcon: {
      title_1: "ปลอดภัยมาตรฐานระดับโลก",
      description_1:
        "เราเก็บรักษาข้อมูลทางการเงินของคุณ ไว้อย่างปลอดภัย ด้วยการเข้ารหัสและเฝ้าระวังการฉ้อโกงทุกวัน ตลอด 24 ชั่วโมง",
      title_2: "ฝากถอนรวดเร็วและมั่นคง",
      description_2:
        "เราตระหนักดีว่า การฝาก-ถอน ที่ง่ายและรวดเร็ว จะช่วยให้เทรดเดอร์ไม่พลาดโอกาสในการซื้อขายที่สำคัญต้อง ฝาก-ถอน ง่าย ไม่ซับซ้อน",
      title_3: "เข้าออเดอร์ทันที่ไม่ต้องรอคิว",
      description_3:
        "ภารกิจของเราคือการให้บริการเทรดเดอร์ เพื่อให้ได้ราคาที่ดีที่สุด เราพยายามอย่างหนักในเทคโนโลยี เพื่อเพิ่มสภาพคล่องให้กับลูกค้า",
      title_4: "เราเป็นพาร์ทเนอร์กับธนาคารทั่วโลก",
      description_4:
        "เราร่วมมือกับธนาคารทั้งในประเทศและต่างประเทศ ให้คุณสามารถรับโบนัสเครดิตจากการฝากเงินเพื่อลดความเสี่ยงให้ได้มากที่สุด",
    },
    accept_policy: `ยอมรับเงื่อนไขและข้อตกลง`,
    policy_dashboard_1: `เรียน ลูกค้าผู้มีเกียรติ,\n\nสิ่งนี้มีผลเฉพาะกลุ่มหุ้นเท่านั้น หากคุณกำลังซื้อขาย Stock(CFDs) โปรดสังเกตการเปลี่ยนแปลงที่จะเกิดขึ้นต่อไปนี้\n\nการซื้อขายโดยการตั้งPending order ล่วงหน้าก่อนตลาดเปิดจะไม่สามารถทำได้ คำสั่งซื้อนี้จะถูกยกเลิกหรือเป็นโมฆะ\n\nคำสั่งซื้อที่มีผลจะต้องเกิดขึ้นหลังตลาดเปิดเท่านั้น\n\nสิ่งนี้มีผลสำหรับเครื่องมือทางการเงินที่เป็นกลุ่ม Stock(CFDs)ทั้งหมด\n\nโปรดพิจารณาข้อมูลนี้และทำการปรับเปลี่ยนกลยุทธ์การซื้อขายของคุณล่วงหน้าหากจำเป็น!\n\nขอบคุณและขอให้เป็นสัปดาห์ที่ดี! ขอแสดงความนับถือ IUX Markets Limited`,

    aboutPage: {
      why_become: "ทำไมต้องเป็นพาร์ทเนอร์ของเรา?",
      Our_in_house:
        "ผู้รวบรวมสปอตในบ้านของเราและเทคโนโลยีการจับคู่คำสั่งซื้อขั้นสูงช่วยให้ผู้ค้าของเราสามารถเข้าถึงกลุ่มสภาพคล่องลึกและการดำเนินการทางการค้าที่รวดเร็วเป็นพิเศษโดยไม่มีการแทรกแซงโต๊ะทำงานเพื่อให้ผู้ค้าสามารถได้รับประโยชน์จากสเปรดที่แน่นหนาและราคาที่แข่งขันได้",
      our_history: {
        header: "ความเป็นมาของพวกเรา",
        detail:
          "นับตั้งแต่การก่อตั้งของเรา IUXmarkets ได้ขยายความสำเร็จเพื่อให้บริการลูกค้ารายย่อยและสถาบันในกว่า 170 ประเทศ - และเรายังคงเติบโตอย่างต่อเนื้อง",
        title_2:
          "IUX Markets Limited. ซึ่งเป็นตัวแทนจำหน่ายที่ได้รับการควบคุมและได้รับอนุญาตด้านหลักทรัพย์การแลกเปลี่ยนCFDs โดยคณะกรรมการบริการทางการเงิน โดยมีเลขทะเบียน  T2023172 BC ที่อยู่จดทะเบียนอาคาร Suite 305, Griffith Corporate Centre,Kingstown St.Vincent and the Grenadines. นอกจากนี้ IUX Markets Limited. ได้รับการลงทะเบียนกับหน่วยงานกำกับดูแลซื้อขาย National Futures Association (NFA) ประเทศสหรัฐอเมริกา ซึ่งทำหน้าที่กำกับดูแลโบรกเกอร์ตลาดอนุพันธ์และตลาดฟิวเจอร์",
      },
      box_1: {
        des_1: `ที่ iuxmarkets เราพัฒนาไปตามเวลา เรามุ่งมั่นที่จะปรับแต่งบริการของเราอย่างต่อเนื่องเพื่อตอบสนองความต้องการของผู้ค้าในอุตสาหกรรมที่มีพลวัตสูงนี้`,
      },
      box_2: {
        des_1: `IUX Markets Limited ซึ่งอยู่ภายใต้การกำกับดูแลของสำนักงานคณะกรรมการกำกับหลักทรัพย์ Financial Services Authority ใน St. Vincent and the Grenadines ได้อนุญาตให้ธุรกิจบริการทางการเงินและหมายเลข `,
        des_2: `ซึ่งจดทะเบียนที่ Beachmont Business Centre, 321, Kingstown, St. Vincent and the Grenadines `,
        // des_2: `ซึ่งจดทะเบียนที่ Beachmont Business Centre, 321, Kingstown, St. Vincent and the Grenadines และ IUX Markets Limited ก็จดทะเบียนกับ MWALI International Services Authority (Comoros) เป็นนายหน้าซื้อขายหลักทรัพย์ CFDs ระหว่างประเทศที่ได้รับการควบคุมและได้รับใบอนุญาตโดยมีหมายเลขใบอนุญาต`,
        des_3: `นอกจากนี้ IUX Markets Limited ยังจดทะเบียนกับหน่วยงานกำกับดูแลการซื้อขาย National Futures Association (NFA) ซึ่งกำกับดูแลโบรกเกอร์อนุพันธ์และฟิวเจอร์สหมายเลข`,
      },
      section_1: {
        title_1: `บริษัท`,
        description_1: `IUX Markets ก่อตั้งขึ้นในปี 2559 โดยเป็นผู้ให้บริการซื้อขาย CFDs ออนไลน์ เส้นทางการซื้อขายของลูกค้ามีความสำคัญต่อเรามากและด้วยเหตุนี้เราจึงมุ่งมั่นที่จะปรับปรุงเทคโนโลยีบริการที่เหมาะและการศึกษาลูกค้า เป็นเวลากว่าทศวรรษที่อุตสาหกรรมและความคาดหวังของลูกค้าพัฒนาไปเรื่อย ๆ เราได้วางตำแหน่งตัวเองอย่างมั่นคงในฐานะโบรกเกอร์ที่ได้รับการควบคุมดูแล`,
        title_2: `บริการของเรา`,
        description_2: `ปัจจุบัน IUX Markets มีบัญชีการซื้อขายแบบสเปรดและแบบคอมมิชชั่น เรามีตราสาร CFDs ที่สามารถแลกเปลี่ยนได้มากกว่า 350 รายการซึ่งรวมถึง CFDs, หุ้น, ดัชนีและสินค้าโภคภัณฑ์ ได้รับการยอมรับอย่างกว้างขวางว่าเป็นโบรกเกอร์ MT4 รายแรกในสหราชอาณาจักรตั้งแต่นั้นมาเราได้เพิ่ม MT4 การซื้อขายบนมือถือและแพลตฟอร์มบนเว็บในชุดแพลตฟอร์มการซื้อขายของเรา`,
        title_3: `วิสัยทัศน์ของเรา`,
        description_3: `เรามุ่งมั่นที่จะเป็นตัวเลือกแรกสำหรับการซื้อขาย CFDs สำหรับนักเทรดที่ต้องการและมีประสบการณ์ เรามุ่งมั่นที่จะมอบประสบการณ์การซื้อขายที่ดีที่สุดให้กับลูกค้าของเราอย่างต่อเนื่องผ่านการบริการลูกค้าที่เชื่อถือได้การกำหนดราคาที่โปร่งใสการดำเนินการซื้อขายที่มีเวลาแฝงต่ำและความเสถียรของแพลตฟอร์ม`,
        title_4: `ค่านิยมของเรา`,
        description_4: `เรามุ่งมั่นที่จะทำให้เทรดเดอร์มีความพร้อม ต่อสภาพแวดล้อมที่มีความเปลี่ยนแปลงตลอดเวลา ด้วยเครื่องมือที่จำเป็นของเรา`,
        title_5: `กลยุทธ์ของเรา`,
        description_5: `ที่ IUX Markets เรามีการพัฒนาอย่างต่อเนื่อง เรามุ่งมั่นตั้งใจที่จะปรับปรุงบริการของเราเพื่อตอบสนองความต้องการของเทรดเดอร์ทุกท่าน`,
      },
      section_2: {
        title: `ค่านิยมของเรา`,
        title_1: `แนวทางลูกค้าเป็นอันดับแรก`,
        title_2: `ความซื่อสัตย์และการปฏิบัติตามข้อกำหนด`,
        title_3: `นวัตกรรม`,
        description_1: `เรามุ่งมั่นที่จะเป็นตัวเลือกแรกสำหรับการซื้อขาย CFDs สำหรับนักเทรดที่ต้องการและมีประสบการณ์ เรามุ่งมั่นที่จะมอบประสบการณ์การซื้อขายที่ดีที่สุดให้กับลูกค้าของเราอย่างต่อเนื่องผ่านการบริการลูกค้าที่เชื่อถือได้การกำหนดราคาที่โปร่งใสการดำเนินการซื้อขายที่มีเวลาแฝงต่ำและความเสถียรของแพลตฟอร์ม`,
        description_2: `เราพยายามให้บริการที่โปร่งใสปลอดภัยและเชื่อถือได้แก่ลูกค้า IUX Markets ได้รับอนุญาตจาก St-Vincent CFDs Broker License `,
        description_3: `IUX Markets มุ่งมั่นที่จะสร้างความมั่นใจในความเร็วในการดำเนินการที่รวดเร็วแพลตฟอร์มการซื้อขายที่มีคุณภาพและการทำธุรกรรมที่ปลอดภัยเป็นมาตรฐานขั้นต่ำสำหรับประสบการณ์การซื้อขายของคุณ`,
      },
      section_3: {
        title: `ระเบียบข้อบังคับ`,
        description: `IUX Markets อยู่ภายใต้การควบคุมโดยใบอนุญาตโบรกเกอร์ St-Vincent CFDs  และเป็นผู้ถือใบอนุญาตตัวแทนจำหน่ายการลงทุน (Discount Broker)`,
        sub_head_title_1: `สถานที่`,
        title_1: `United Kingdom`,
        title_2: ``,
        title_3: `Singapore`,
        description_1: `6-8 Revenge Road, Suite 2096 United Kingdom ME5 8UD Chatham, UK support@iuxmarket.com`,
        description_2: `P.B. 1257 Bonovo Road, Fomboni, Comoros, KM.`,
        description_3: `30 Paya Lebar Road, #01-37, Paya Lebar Square, Singapore 409051`,
      },
    },

    accountType: {
      standard: `บัญชียอดนิยม สเปรดต่ำที่สุด ไม่มีค่าคอมมิชชั่น เหมาะสำหรับการเทรดทุกรูปแบบ สำหรับนักลงทุนทุกระดับ ไม่มีค่าธรรมเนียมฝาก-ถอน`,
      list: {
        list_1: `สเปรด 0.2 PIPs`,
        list_2: `Leverage สูงสุด 1:3000`,
        list_3: `No Swap`,
        list_4: `ฝากขั้นต่ำ $10`,
      },
      cent: `บัญชีสำหรับนักลงทุนเริ่มต้นโดยใช้หน่วยลงทุนน้อยกว่า เหมาะสำหรับการเทรดทุกรูปแบบ`,
      list_cent: {
        list_1: `สเปรด 0.2 PIPs`,
        list_2: `Leverage สูงสุด 1:3000`,
        list_3: `No Swap`,
        list_4: `ฝากขั้นต่ำ $10`,
      },
      standard_bonus: `บัญชีโบนัส 35% เหมาะสำหรับการเทรดระยะยาว ไม่มีค่าธรรมเนียม`,
      list_bonus: {
        list_1: `สเปรด 0.5 PIPs`,
        list_2: `Leverage สูงสุด 1:1000`,
        list_3: `โบนัสเงินฝาก 35%`,
        list_4: `ฝากขั้นต่ำ $10`,
      },
      standard_ecn: `บัญชีนักลงทุน VIP สเปรดต่ำ เริ่มต้น 0.0 PIPs ค่าธรรมเนียม $3.5/Lot ค่าธรรมเนียมฝากถอนฟรี`,
      list_ecn: {
        list_1: `สเปรด 0.0 PIPs`,
        list_2: `Leverage สูงสุด 1:3000`,
        list_3: `ค่าธรรมเนียม $3.5/Lot`,
        list_4: `ฝากขั้นต่ำ $200`,
      },
      standard_raw: `บัญชีนักลงทุน VIP สเปรดต่ำ เริ่มต้น 0.0 PIPs ค่าธรรมเนียม $6/Lot ค่าธรรมเนียมฝากถอนฟรี`,
      list_raw: {
        list_1: `สเปรด 0.0 PIPs`,
        list_2: `Leverage สูงสุด 1:3000`,
        list_3: `ค่าธรรมเนียม $6/Lot`,
        list_4: `ฝากขั้นต่ำ $200`,
      },
      standard_pro: `เทรดด้วยสเปรดที่ต่ำที่สุด ดำเนินการคำสั่งซื้อขายได้ยอดเยี่ยม ลด slippage อาจมีรีโควตหากราคาในตลาดเปลี่ยนแปลงอย่างรวดเร็ว`,
      list_pro: {
        list_1: `สเปรด 0.1 PIPs`,
        list_2: `ไม่มีค่าคอมมิชชั่น`,
        list_3: `ฝากขั้นต่ำ 1000 USD`,
        list_4: `ขั้นต่ำ 0.1 Lot size`,
      },
      btn: {
        real: `เปิดบัญชีซื้อขายจริง`,
        demo: `ทดลองซื้อขายในบัญชีทดลอง`,
      },
    },
  },
  lo: {
    aboutMeTitle:
      "IUX Markets ເລີ່ມຕົ້ນເພື່ອເສີມຂະຫຍາຍການຊື້ຂາຍກັບລະດັບຄວາມປອດໄພສູງ. ເຄື່ອງມືການຄ້າທີ່ວ່ອງໄວ, ກ້າວໜ້າ ແມ່ນຖືກໃຊ້ໃນຕະຫຼາດ CFDs ແລະພວກເຮົາໄດ້ເຫັນບັນຫາການຊື້ຂາຍຫຼາຍຢ່າງແລະໄດ້ປະຕິບັດເພື່ອປັບປຸງ ເພື່ອສະໜອງລູກຄ້າ ການເຂົ້າເຖິງລະບົບການຊື້ຂາຍແລະການເຮັດທຸລະກຳຂອງພວກເຮົາໄດ້ໄວແລະປອດໄພພວກ ຈາກການອຸທິດເວລາແລະຄວາມເຂົ້າໃຈຄວາມສຳຄັນຂອງຕະຫຼາດເງິນ ທີ່ມີການຢ່າງໄວວາແລະມີປະສິດທິພາບ ທຸກໆການຕັດສິນໃຈຂອງພວກເຮົາມັນມີຈຸດປະສົງເພື່ອຮັບປະກັນໃຫ້ລູກຄ້າແລະຄູ່ຮ່ວມທຸລະກິດຂອງພວກເຮົາ ພ້ອມທັງທີມງານຊ່ຽວຊານ, ພວກເຮົາເຊື່ອວ່າຄວາມຮູ້ແມ່ນພະລັງ. ແລະເປັນ ກຳ ລັງໃຈໃຫ້ພໍ່ຄ້າຊາວຂາຍ ໄດ້ຮັບຜົນການລົງທືນທີ່ດີທີ່ສຸດ",
    aboutMeIcon: {
      title_1: "ປອດໄພກັບມາດຕະຖານລະດັບໂລກ",
      description_1:
        "ພວກເຮົາຮັກສາຂໍ້ມູນການເງິນຂອງທ່ານ ປອດໄພດ້ວຍການເຂົ້າລະຫັດແລະການເຝົ້າລະວັງການສໍ້ໂກງ ຕລອດ 24 ຊົ່ວໂມງ",
      title_2: "ຝາກແລະຖອນຄືນໄດ້ໄວແລະ ໝັ້ນ ຄົງ",
      description_2:
        "ພວກເຮົາຮັບຮູ້ວ່າການຝາກແລະຖອນເງິນແມ່ນງ່າຍແລະວ່ອງໄວ. ນີ້ຈະຊ່ວຍໃຫ້ພໍ່ຄ້າບໍ່ຄວນພາດໂອກາດການຄ້າທີ່ສຳຄັນ,ງ່າຍຕໍ່ການຝາກແລະຖອນ.",
      title_3: "ກະລຸນາໃສ່ຄຳສັ່ງທັນທີໂດຍບໍ່ຕ້ອງລໍຖ້າ",
      description_3:
        "ພາລະກິດຂອງພວກເຮົາແມ່ນເພື່ອຮັບໃຊ້ເທຮດເດ້ເພື່ອໃຫ້ໄດ້ລາຄາທີ່ດີທີ່ສຸດ ພວກເຮົາເຮັດວຽກໜັກໃນເຕັກໂນໂລຢີ ເພື່ອເພີ່ມສະພາບຄ່ອງໃຫ້ແກ່ລູກຄ້າ",
      title_4: "ພວກເຮົາເປັນຄູ່ຮ່ວມມືກັບທະນາຄານທົ່ວໂລກ",
      description_4:
        "ພວກເຮົາຮ່ວມມືກັບທັງທະນາຄານທັງພາຍໃນແລະຕ່າງປະເທດ ອະນຸຍາດໃຫ້ທ່ານໄດ້ຮັບໂບນັດສິນເຊື່ອໃນເງິນຝາກຂອງທ່ານເພື່ອຫຼຸດຜ່ອນຄວາມສ່ຽງຂອງທ່ານ",
    },
    accept_policy: `ຍອມຮັບເງື່ອນໄຂແລະຂໍ້ຕົກລົງ`,
    policy_dashboard_1: `ລູກຄ້າທີ່ຮັກແພງ,\n\nອັນນີ້ໃຊ້ໄດ້ກັບຮຸ້ນເທົ່ານັ້ນ. ຖ້າເຈົ້າກໍາລັງຊື້ຂາຍຫຼັກຊັບ (Stock CFDs), ກະລຸນາບັນທຶກການປ່ຽນແປງຕໍ່ໄປນີ້.\n\nການຊື້ຂາຍໂດຍກໍານົດຄໍາສັ່ງທີ່ຍັງຄ້າງຢູ່ກ່ອນທີ່ຕະຫຼາດເປີດແມ່ນບໍ່ເປັນໄປໄດ້.\n\nຄຳ ສັ່ງນີ້ຈະຖືກຍົກເລີກຫຼືຍົກເລີກ. ຄໍາສັ່ງທີ່ມີການເຄື່ອນໄຫວຕ້ອງໄດ້ວາງໄວ້ພຽງແຕ່ຫຼັງຈາກຕະຫຼາດເປີດ.\n\nຜົນກໍຄື, ອັນນີ້ໃຊ້ໄດ້ກັບເຄື່ອງມືການເງິນກຸ່ມ. ຫຸ້ນທັງ(ົດ (Stock CFDs)\n\nກະລຸນາພິຈາລະນາຂໍ້ມູນນີ້ແລະປັບປ່ຽນຍຸດທະສາດການຊື້ຂາຍຂອງເຈົ້າລ່ວງ ໜ້າ ຖ້າຈໍາເປັນ!\n\nຂອບໃຈແລະມີອາທິດທີ່ດີ! ດ້ວຍຄວາມນັບຖື, IUX Markets Limited.`,

    accountType: {
      standard: `ບັນຊີການແຜ່ກະຈາຍຕໍ່າສຸດ Leverage 1:3000 ຄ່າຝາກແລະຖອນເງິນຟຣີ`,
      list: {
        list_1: `Spread 0.2 PIPs`,
        list_2: `Leverage ສູງສຸດ 1:3000`,
        list_3: `No Swap`,
        list_4: `ເງິນຝາກຕ່ ຳສຸດ $10`,
      },
      cent: `ບັນ​ຊີ​ສໍາ​ລັບ​ນັກ​ລົງ​ທຶນ​ເລີ່ມ​ຕົ້ນ​ທີ່​ມີ​ຫົວ​ຫນ່ວຍ​ການ​ລົງ​ທຶນ​ຫນ້ອຍ​ເຫມາະ​ສົມ​ສໍາ​ລັບ​ການ​ຄ້າ​ທຸກ​ປະ​ເພດ **`,
      list_cent: {
        list_1: `Spread 0.2 PIPs`,
        list_2: `Leverage ສູງສຸດ 1:3000`,
        list_3: `No Swap`,
        list_4: `ເງິນຝາກຕ່ ຳສຸດ $10`,
      },
      standard_bonus: `ບັນຊີຍອດນິຍົມໄດ້ຮັບໂບນັດເງິນຝາກສູງເຖິງ 35%, ເໝາະ ສົມກັບການຊື້ຂາຍທຸກປະເພດ ຄ່າຝາກແລະຖອນເງິນຟ`,
      list_bonus: {
        list_1: `Spread 0.5 PIPs`,
        list_2: `Leverage ສູງສຸດ 1:1000`,
        list_3: `ໂບນັດເງິນຝາກ 35%`,
        list_4: `ເງິນຝາກຕ່ ຳສຸດ $10`,
      },
      standard_ecn: `ບັນຊີ Spraed ต่ำ ເລີ່ມຕົ້ນ 0.0 PIPs ຄ່າທຳນຽມ $3.5/Lot ຖອນເງິນຝາກໂດຍບໍ່ເສຍຄ່າ`,
      list_ecn: {
        list_1: `Spread 0.0 PIPs`,
        list_2: `Leverage ສູງສຸດ 1:3000`,
        list_3: `ຄ່າທຳນຽມ $3.5/Lot`,
        list_4: `ເງິນຝາກຕ່ ຳ ສຸດ $200`,
      },
      standard_raw: `ບັນຊີ Spraed ต่ำ ເລີ່ມຕົ້ນ 0.0 PIPs ຄ່າທຳນຽມ $6/Lot ຖອນເງິນຝາກໂດຍບໍ່ເສຍຄ່າ`,
      list_raw: {
        list_1: `Spread 0.0 PIPs`,
        list_2: `Leverage ສູງສຸດ 1:3000`,
        list_3: `ຄ່າທຳນຽມ $6/Lot`,
        list_4: `ເງິນຝາກຕ່ ຳ ສຸດ $200`,
      },
      standard_pro: `ການຄ້າທີ່ມີການແຜ່ກະຈາຍຕໍ່າສຸດການຕື່ມຂໍ້ມູນທີ່ດີເລີດແລະຫຼຸດການເລື່ອນລົງ. ຄຳ ຮຽກຮ້ອງອາດຈະເກີດຂຶ້ນໃນຕະຫຼາດທີ່ມີການເຄື່ອນໄຫວໄວ`,
      list_pro: {
        list_1: `Spread 0.1 PIPs`,
        list_2: `No Commission`,
        list_3: `Minimum Deposit 1000 USD`,
        list_4: `0.1 Minimum  Lot size`,
      },
      btn: {
        real: `ເປີດບັນຊີເທຣດຈິງ`,
        demo: `ຊື້ຂາຍໃນບັນຊີສາທິດ`,
      },
    },

    aboutPage: {
      why_become: "ເປັນຫຍັງຈຶ່ງກາຍເປັນຄູ່ຮ່ວມງານຂອງພວກເຮົາ??",
      Our_in_house:
        "ນັບຕັ້ງແຕ່ສະຖາບັນການສ້າງຕັ້ງ, ຕະຫຼາດ IUX ໄດ້ຂະຫຍາຍອອກໄປຮັບໃຊ້ລູກຄ້າຂາຍຍ່ອຍແລະສະຖາບັນໃນຫລາຍກວ່າ 170 ປະເທດ - ແລະພວກເຮົາຍັງເຕີບໃຫຍ່.",
      our_history: {
        header: "ປະຫວັດຂອງພວກເຮົາ",
        detail:
          "นับตั้งแต่การก่อตั้งของเรา IUXmarkets ได้ขยายความสำเร็จเพื่อให้บริการลูกค้ารายย่อยและสถาบันในกว่า 170 ประเทศ - และเรายังคงเติบโตอย่างต่อเนื้อง",
        title_2:
          "IUX Markets Limited. Which is subject to supervision by the Securities Commission. Financial Services Authority Has allowed the business of financial services and number  T2023172 Registered Address: P.B. 1257 Bonovo Road, Fomboni, Comoros, KM. and the Grenadines and IUX Markets Limited. also registered with the National Futures Association (NFA) from United States which designated by the CFTC as a registered futures association. NFA strives everyday to safeguard the integrity of the derivatives markets, protect investors and ensure members meet their regulatory responsibilities.",
      },
      box_1: {
        des_1: `ຕະຫຼາດ iux ສະເຫນີການຊື້ຂາຍໃນຮຸ້ນ, ຈຸດຕົວຊີ້ວັດ, ອະນາຄົດ, ໂລຫະປະດັບຈຸດແລະຈຸດໄຟຟ້າ. ພວກເຮົາໃຫ້ລູກຄ້າຂອງພວກເຮົາໃນການເຂົ້າເຖິງສະພາບຄ່ອງແລະການຊື້ຂາຍທີ່ກ້າວຫນ້າແລະການປະຕິບັດການຄ້າທີ່ກ້າວຫນ້າໂດຍບໍ່ມີການແຊກແຊງ Desk Dealing.`,
      },
      box_2: {
        des_1: `IUX Markets Limited, ເຊິ່ງຂຶ້ນກັບການຊີ້ນໍາຂອງຄະນະກໍາມະການຫຼັກຊັບ. ອົງການການບໍລິການທາງດ້ານການເງິນໃນ Saint Vincent ແລະ Grenadines ໄດ້ອະນຸຍາດໃຫ້ທຸລະກິດການບໍລິການທາງດ້ານການເງິນແລະເລກທີ່`,
        des_2: `, ລົງທະບຽນຢູ່ Beachmont Business Centre, 321, Kingstown, St. Vincent ແລະ Grenadines`,
        // des_2: `, ລົງທະບຽນຢູ່ Beachmont Business Centre, 321, Kingstown, St. Vincent ແລະ Grenadines ແລະ IUX Markets Limited ຍັງລົງທະບຽນກັບອົງການບໍລິການສາກົນ MWALI ( Comoros) ເປັນນາຍໜ້າທີ່ມີການຄວບຄຸມ ແລະ ອະນຸຍາດຂອງການຊື້ຂາຍຫຼັກຊັບ CFDs ສາກົນທີ່ມີໝາຍເລກໃບອະນຸຍາດ `,
        des_3: `ນອກຈາກນັ້ນ, IUX Markets Limited ແມ່ນໄດ້ລົງທະບຽນກັບ National Futures Association (NFA) regulator, ເຊິ່ງຄວບຄຸມນາຍຫນ້າຊື້ຂາຍອະນຸພັນແລະອະນາຄົດ,`,
      },
      section_1: {
        title_1: `ບໍລິສັດ`,
        description_1: `IUX Markets ກໍ່ຕັ້ງຢູ່ລອນດອນໃນປີ ຄ.ສ.2017 ໂດຍການເປັນຜູ້ໃຫ້ບໍລິການດ້ານຊື້ຂາຍ CFDs ອອນລາຍ ເສັ້ນທາງການຄ້າຂອງລູກຄ້າແມ່ນມີຄວາມ ສຳ ຄັນຫຼາຍຕໍ່ພວກເຮົາແລະເປັນຜົນມາຈາກການທີ່ພວກເຮົາມຸ້ງໝັ້ນ ໃນການປັບປຸງເຕັກໂນໂລຢີ ການບໍລິການທີ່ ເໝາະ ສົມແລະການສຶກສາລູກຄ້າ ເປັນເວລາຫຼາຍກວ່າໜຶ່ງທົດສະວັດຍ້ອນວ່າຄວາມຄາດຫວັງຂອງລູກຄ້າ ແລະຍັງສືບຕໍ່ມີການປ່ຽນແປງພວກເຮົາໄດ້ວາງຕຳແໜ່ງ ຕົວເຮົາເອງໃຫ້ເປັນນາຍໜ້າທີ່ດີ`,
        title_2: `ບໍລິການຂອງພວກເຮົາ`,
        description_2: `ປະຈຸບັນ IUX Markets ມີບັນຊີການຊື້ຂາຍທີ່ແຜ່ຂະຫຍາຍແລະຄ່ານາຍໜ້າ ພວກເຮົາມີເຄື່ອງມື CFDs ນັ້ນສາມາດຊື້ຂາຍໄດ້ຫຼາຍ 350 ບັນຊີລາຍຊື່ທີ່ປະກອບມີ CFDs, ຫຸ້ນ, ດັດສະນີແລະສິນຄ້າ ມັນໄດ້ຖືກຮັບຮູ້ຢ່າງກວ້າງຂວາງວ່າເປັນນາຍຫນ້າ MT4 ຄັ້ງທໍາອິດໃນອັງກິດນັບຕັ້ງແຕ່ນັ້ນມາພວກເຮົາໄດ້ເພີ່ມ MT4 ການຊື້ຂາຍມືຖືແລະເວບໄຊທ໌ເຂົ້າໃນຊຸດຂອງເວທີການຄ້າຂອງພວກເຮົາ`,
        title_3: `ວິໄສທັດຂອງພວກເຮົາ`,
        description_3: `ພວກເຮົາພະຍາຍາມເປັນທາງເລືອກທຳອິດໃນການຊື້ຂາຍ CFDs ສຳ ລັບເທຮດເດ້ທີ່ປາຖະໜາແລະມີປະສົບການ ພວກເຮົາພະຍາຍາມຢ່າງບໍ່ຢຸດຢັ້ງເພື່ອໃຫ້ມີປະສົບການທາງການຄ້າທີ່ດີທີ່ສຸດ ສຳ ລັບລູກຄ້າຂອງພວກເຮົາໂດຍຜ່ານການບໍລິການລູກຄ້າທີ່ ໜ້າເຊື່ອຖືລາຄາທີ່ໂປ່ງໃສ, ການປະຕິບັດການຄ້າທີ່ມີລະດັບຕໍ່າແລະຄວາມໝັ້ນຄົງຂອງແພລດຕະຟອມ`,
        description_4: `We are committed to creating a dynamic
                    environment that equips traders with all the necessary tools
                    for their trading experience with the utmost respect for
                    them.`,
        title_5: `Our Strategy`,
        description_5: `At IUXMARKETS we evolve with the times. We aim to continuously refine our services to cater to the needs of traders in this highly dynamic industry.`,
      },
      section_2: {
        title: `ຄ່ານິຍົມຂອງພວກເຮົາ`,
        title_1: `ລູກຄ້າຕ້ອງມາກ່ອນ`,
        title_2: `ຄວາມຊື່ສັດແລະການປະຕິບັດຕາມ`,
        title_3: `ນະວັດຕະກຳ`,
        description_1: `ພວກເຮົາພະຍາຍາມເປັນທາງເລືອກ ທຳອິດໃນການຊື້ຂາຍ CFDs ສຳລັບພໍ່ຄ້າທີ່ປາຖະໜາ ແລະມີປະສົບການ ວກເຮົາພະຍາຍາມຢ່າງບໍ່ຢຸດຢັ້ງເພື່ອໃຫ້ມີປະສົບການທາງການຄ້າທີ່ດີທີ່ສຸດ ສຳ ລັບລູກຄ້າຂອງພວກເຮົາໂດຍຜ່ານການບໍລິການລູກຄ້າທີ່ໜ້າເຊື່ອຖື, ລາຄາທີ່ໂປ່ງໃສການປະຕິບັດການຄ້າທີ່ມີລະດັບຕໍ່າແລະຄວາມໝັ້ນຄົງຂອງແພລດຕະຟອມ`,
        description_2: `ພວກເຮົາພະຍາຍາມໃຫ້ບໍລິການທີ່ໂປ່ງໃສ ປອດໄພແລະເຊື່ອຖືໄດ້ແກ່ລູກຄ້າຂອງພວກເຮົາ IUX Markets ອະນຸຍາດໂດຍ St-Vincent CFDs Broker License `,
        description_3: `IUX Markets ມີຄວາມມຸ້ງ ໝັ້ນ ທີ່ຈະຮັບປະກັນຄວາມໄວໃນການປະຕິບັດທີ່ວ່ອງໄວ ແພລດຕະຟອມການຄ້າທີ່ມີຄຸນນະພາບແລະການເຮັດທຸລະກຳ ທີ່ປອດໄພແມ່ນມາດຕະຖານຕ່ ຳ ສຸດສຳລັບປະສົບການການຄ້າຂອງທ່ານ`,
      },
      section_3: {
        title: `ລະບຽບການ`,
        description: `ຕະຫຼາດ IUX ມັນຖືກຄວບຄຸມໂດຍໃບອະນຸຍາດ broker St-Vincent CFDs  ແລະເປັນຜູ້ຖືໃບອະນຸຍາດຊື້ຂາຍການລົງທືນ (Discount Broker)`,
        sub_head_title_1: `ສະ​ຖານ​ທີ່`,
        title_1: `United Kingdom`,
        title_2: ``,
        title_3: `Singapore`,
        description_1: `6-8 Revenge Road, Suite 2096 ສະຫະລາດຊະອານາຈັກ ME5 8UD Chatham, UK support@iuxmarket.com`,
        description_2: `P.B. 1257 Bonovo Road, Fomboni, Comoros, KM.`,
        description_3: `30 Paya Lebar Road, #01-37, Paya Lebar Square, Singapore 409051 support@iuxmarkets.com`,
      },
    },
  },
  hi: {
    aboutMeTitle:
      "IUX Markets started to raise the level of trading to a high level of security. Swift executions with world’s best technology in the CFDs market. We have observed numerous issues with trading and have taken action to fix them; to allow customers to be able to access the trading system and conduct various transactions quickly and safely. We also value Commodities at all times from devoting time and understanding the importance of the world of financial markets that fluctuate quickly and efficiently. Every decision we make is to ensure that our customers and business partners, including our team of experts, spend time wisely. We believe that knowledge is power and encouraging traders to get the best investment results is our desire.",
    aboutMeIcon: {
      title_1: "World Class Safety Standards",
      description_1:
        "We keep your data safe and secure with encryption and 24/7 surveillance.",
      title_2: "Fast transactions are our priority. \n",
      description_2:
        "We truly understand the experience of traders that is why we make everything simple.",
      title_3: "High-Speed Execution",
      description_3:
        "We want our clients to have the best trading experience. With this level of speed, you will not miss the opportunity.",
      title_4: "We partner with banks around the world.\n",
      description_4:
        "We cooperate with domestic and foreign banks. Allowing you to receive bonus credits from depositing funds to minimize the risk as much as possible.",
    },
    accept_policy: `Accept the terms and conditions`,
    policy_dashboard_1: `Dear Customers,\n\nThis only has an impact on stocks. Please note of the following updates if you trade stocks (CFDs).\n\nTrading by setting pending orders before the market opens is not possible.\n\nThe order will be invalidated or canceled.Only once the market opens can active orders be placed.As a result, group financial instruments are covered all Stocks (CFDs).\n\nPlease consider this information and make adjustments to your trading strategy in advance if necessary!\n\nBest Regards, IUX Markets Limited.`,
    accountType: {
      standard: `Top accounts with lowest spread No commissions Suitable for all types of trading For investors of all levels , No deposit and withdrawal fees`,
      list: {
        list_1: `Spread from 0.2 PIPs`,
        list_2: `Max Leverage 1:3000`,
        list_3: `No Commission`,
        list_4: `Minimum deposit 10 USD`,
      },
      cent: `An account for beginner investors with fewer investment units Suitable for all types of trading `,
      list_cent: {
        list_1: `Spread from 0.2 PIPs`,
        list_2: `Max Leverage 1:3000`,
        list_3: `No Commission`,
        list_4: `Minimum deposit 10 USD`,
      },
      standard_bonus: `35% bonus account suitable for long term trading. No fees , No deposit and withdrawal fees`,
      list_bonus: {
        list_1: `Spread from 0.5 PIPs`,
        list_2: `Max Leverage 1:1000`,
        list_3: `35% Deposit Bonus`,
        list_4: `Minimum deposit 10 USD`,
      },
      standard_ecn: `VIP Investor account spread start from 0.0 PIPs, commission is just $ 3.5 only, No deposit and withdrawal fees`,
      list_ecn: {
        list_1: `Spread from 0.0 PIPs`,
        list_2: `Max Leverage 1:3000`,
        list_3: `$3.5 Commission`,
        list_4: `Minimum deposit 200 USD`,
      },
      standard_raw: `VIP Investor account spread start from 0.0 PIPs, commission is just $ 7 only, No deposit and withdrawal fees`,
      list_raw: {
        list_1: `Spread from 0.0 PIPs`,
        list_2: `Max Leverage 1:3000`,
        list_3: `$6 Commission`,
        list_4: `Minimum deposit 200 USD`,
      },
      standard_pro: `Trade with the lowest spread Excellent fill and reduced slippage. Requotes may happen in fast-moving markets`,
      list_pro: {
        list_1: `Spread 0.1 PIPs`,
        list_2: `No Commission`,
        list_3: `Minimum Deposit 1000 USD`,
        list_4: `0.1 Minimum  Lot size`,
      },
      btn: {
        real: `Open a real trading account`,
        demo: `Trading on a demo account`,
      },
    },

    aboutPage: {
      why_become: "हमारे साथी क्यों बनें?",
      Our_in_house:
        "हमारे इन-हाउस स्पॉट एग्रीगेटर और एडवांस्ड ऑर्डर-मैचिंग तकनीक हमारे व्यापारियों को एक गहरी तरलता पूल और अल्ट्रा-फास्ट ट्रेड निष्पादन के साथ बिना किसी डीलिंग डेस्क हस्तक्षेप के साथ पहुंच प्रदान करते हैं ताकि व्यापारियों को तंग प्रसार और प्रतिस्पर्धी मूल्य निर्धारण से लाभ हो सके।",
      our_history: {
        header: "हमारा इतिहास",
        detail:
          "हमारी स्थापना के बाद से, IUX Marketsने 170 से अधिक देशों में खुदरा और संस्थागत ग्राहकों की सेवा के लिए सफलतापूर्वक विस्तार किया है - और हम अभी भी बढ़ रहे हैं।",
        title_2:
          "IUX Markets Limited. Which is subject to supervision by the Securities Commission. Financial Services Authority Has allowed the business of financial services and number  T2023172 Registered Address:P.B. 1257 Bonovo Road, Fomboni, Comoros, KM. and the Grenadines and IUX Markets Limited. also registered with the National Futures Association (NFA) from United States which designated by the CFTC as a registered futures association. NFA strives everyday to safeguard the integrity of the derivatives markets, protect investors and ensure members meet their regulatory responsibilities.",
      },
      box_1: {
        des_1: `IUX मार्केट्स शेयरों, स्पॉट इंडिस, फ्यूचर्स, स्पॉट मेटल्स और स्पॉट एनर्जी पर ट्रेडिंग प्रदान करता है। हम अपने ग्राहकों को शीर्ष-स्तरीय तरलता और उन्नत व्यापार निष्पादन तक पहुंच प्रदान करते हैं, जिसमें कोई डीलिंग डेस्क हस्तक्षेप नहीं है।`,
      },
      box_2: {
        des_1: `IUX Markets Limited, जो प्रतिभूति आयोग द्वारा पर्यवेक्षण के अधीन है। सेंट विंसेंट और ग्रेनेडाइंस में वित्तीय सेवा प्राधिकरण ने वित्तीय सेवाओं और संख्या`,
        // des_2: `के कारोबार की अनुमति दी है, जो Beachmont Business Centre, 321, Kingstown, St. Vincent and the Grenadines और IUX Markets Limited में पंजीकृत है और MWALI अंतर्राष्ट्रीय सेवाओं के साथ भी पंजीकृत है। प्राधिकरण (Comoros) लाइसेंस संख्या`,
        des_2: `के कारोबार की अनुमति दी है, जो Beachmont Business Centre, 321, Kingstown, St. Vincent and the Grenadines `,
        des_3: `के साथ अंतरराष्ट्रीय सीएफडी ट्रेडिंग प्रतिभूतियों के एक विनियमित और लाइसेंस प्राप्त दलाल के रूप में।\nइसके अलावा, IUX Markets Limited नेशनल फ्यूचर्स एसोसिएशन (NFA) ट्रेडिंग रेगुलेटर के साथ पंजीकृत है, जो डेरिवेटिव और फ्यूचर ब्रोकर्स की निगरानी करता है, `,
      },
      section_1: {
        title_1: `Company History`,
        description_1: `IUX Markets was established  in 2016 as a provider of online CFDs trading services. Our client’s trading journey is very important to us, and as such we are always committed in refining our technology, tailored services and client education. For over a decade, as the industry and clients’ expectations keep evolving, we have positioned ourselves firmly as a trusted and leading  regulated broker.`,
        title_2: `Our Services`,
        description_2: `IUX Markets currently offers a spread-based and a commission-based trading account. We have more than 350 tradeable CFDs instruments including CFDs, Shares, Indices and Commodities. Widely recognised as the first MT4 broker in United Kingdom, we have since added MT4,mobile trading and a web-based platform to our suite of trading platforms.`,
        title_3: `Our Vision`,
        description_3: `We strive to be the first choice for trading CFDs for aspiring and experienced traders. We strive to continuously provide the best trading experience to our clients through reliable customer service, transparent pricing, low-latency trade execution and platform stability.`,
        description_4: `We are committed to creating a dynamic
                    environment that equips traders with all the necessary tools
                    for their trading experience with the utmost respect for
                    them.`,
        title_5: `Our Strategy`,
        description_5: `At IUXMARKETS we evolve with the times. We aim to continuously refine our services to cater to the needs of traders in this highly dynamic industry.`,
      },
      section_2: {
        title: `Our Values`,
        title_1: `Client-first approach`,
        title_2: `Integrity and Compliance`,
        title_3: `Innovation`,
        description_1: `We strive to be the first choice for trading CFDs for aspiring and experienced traders. We strive to continuously provide the best trading experience to our clients through reliable customer service, transparent pricing, low-latency trade execution and platform stability.`,
        description_2: `We endeavour to provide clients with transparent, secure and reliable services. IUX Markets is licensed by the St-Vincent CFDs Broker License `,
        description_3: `IUX Markets is dedicated to ensuring fast execution speed, quality trading platforms and secure transactions as a minimum standard for your trading experience.`,
      },
      section_3: {
        title: `Regulation`,
        description: `IUX Markets is regulated by the St-Vincent CFDs Broker License  and is a holder of an Investment Dealer (Discount Broker)`,
        sub_head_title_1: `Locations`,
        title_1: `United Kingdom`,
        title_2: ``,
        title_3: `Singapore`,
        description_1: `6-8 Revenge Road , Suite 2096 United Kingdom \nME5 8UD Chatham, UK support@iuxmarket.com`,
        description_2: `P.B. 1257 Bonovo Road, Fomboni, Comoros, KM. `,
        description_3: `30 Paya Lebar Road, #01-37, Paya Lebar Square, \nSingapore 409051 `,
      },
    },
  },

  ms: {
    aboutMeTitle:
      "IUX Markets dimulakan untuk meningkatkan dagangan dengan tahap keselamatan yang tinggi. Memproses setiap langkah dengan pantas dan progresif. Dengan alat dagangan terkini dalam pasaran CFDs. Kami telah melihat banyak masalah dagangan dan berusaha untuk menyelesaikannya supaya dapat menyediakan sistem perdagangan yang boleh diakses dan proses urus niaga dilaksanakan dengan cepat dan selamat kepada pelanggan. Kami menghargai komoditi yang berharga pada setiap masa dengan menumpukan masa dan memahami kepentingan dunia Pasaran wang yang mengalami turun naik dengan pantas dan cekap. Setiap keputusan yang kami buat bermatlamat untuk memastikan pelanggan dan rakan kongsi perniagaan kami, serta pasukan pakar kami menggunakan masa mereka dengan bijak. Kami percaya bahawa pengetahuan adalah kuasa dan menggalakkan peniaga mendapat hasil pelaburan terbaik adalah keinginan kami.",
    aboutMeIcon: {
      title_1: "Keselamatan berstandard dunia",
      description_1:
        "Kami menyimpan maklumat kewangan anda dengan selamat. Dengan menetapkan kata laluan dan pemantaun terhadap penipuan selama 24 jam",
      title_2: "Deposit dan pengeluaran yang cepat dan stabil\n",
      description_2:
        "Kami menyedari bahawa deposit dan pengeluaran yang cepat dan mudah akan membantu pelabur supaya tidak terlepas dari peluang perdagangan penting yang memerlukan pengeluaran-deposit yang mudah dan tidak rumit.",
      title_3:
        "Masukkan pesanan dengan serta-merta, tidak perlu menunggu giliran ",
      description_3:
        "Misi kami adalah untuk berkhidmat kepada peniaga supaya mendapatkan harga terbaik. Kami gigih berusaha membangun teknologi untuk meningkatkan kelancaran kepada pelanggan",
      title_4: "Kami bekerjasama dengan bank-bank seluruh dunia. \n",
      description_4:
        "Kami bekerjasama dengan bank-bank tempatan dan antarabangsa. Membolehkan anda untuk menerima kredit bonus daripada simpanan dana untuk mengurangkan risiko sebanyak mungkin.",
    },
    accept_policy: `Terima syarat dan ketentuan`,
    policy_dashboard_1: `Pelanggan yang Dihormati,\n\nPerkara ini berlaku kepada kumpulan saham sahaja. Jika anda sedang lakukan dagangan Stock (CFDs), sila ambil perhatian perubahan berikut \n\nBerdagang dengan menetapkan Pending order sebelum pasaran dibuka tidak dibolehkan. Pesanan ini akan dibatalkan atau tidak berlaku.\n\nPesanan yang berkesan hendaklah dibuat hanya selepas pembukaan pasaran.\n\nIni sah untuk semua instrumen kewangan berkumpulan Stock (CFDs)\n\nSila pertimbangkan maklumat ini dan buat pelarasan pada strategi dagangan anda terlebih dahulu jika perlu!\n\nTerima kasih dan selamat berhujung minggu! Hormat Kami, IUX Markets Limited,`,
    accountType: {
      standard: `Akaun popular, spread terendah, tiada komisen sesuai untuk semua jenis perdagangan dan peringkat pelabur tanpa yuran pengeluaran-deposit`,
      list: {
        list_1: `Spread dari 0.2 Pip’`,
        list_2: ` Leverage Maksimum 1:3000`,
        list_3: `Tiada komisen`,
        list_4: `Minimum deposit 10 USD`,
      },
      cent: `Akaun untuk pelabur pemula dengan unit pelaburan yang lebih sedikit. Sesuai untuk semua jenis perdagangan`,
      list_cent: {
        list_1: `Spread dari 0.2 Pip’`,
        list_2: ` Leverage Maksimum 1:3000`,
        list_3: `Tiada komisen`,
        list_4: `Minimum deposit 10 USD`,
      },
      standard_bonus: `Akaun bonus 35% sesuai untuk perdagangan jangka panjang tanpa yuran`,
      list_bonus: {
        list_1: `Spread dari 0.5 PIPs`,
        list_2: ` Leverage Maksimum 1:1000`,
        list_3: `35% Deposit Bonus`,
        list_4: `Minimum deposit 10 USD`,
      },
      standard_ecn: `Akaun Pelabur VIP spread rendah mula dari 0.0 PIPs, Yuran $3.5/Lot, Yuran deposit-pengeluaran percuma`,
      list_ecn: {
        list_1: `Spread dari 0.0 PIPs`,
        list_2: ` Leverage Maksimum 1:3000`,
        list_3: `Komisen $3.5 `,
        list_4: `Minimum deposit 200 USD`,
      },
      standard_raw: `Akaun Pelabur VIP spread rendah mula dari 0.0 PIPs, Yuran $6/Lot, Yuran deposit-pengeluaran percuma`,
      list_raw: {
        list_1: `Spread dari 0.0 PIPs`,
        list_2: ` Leverage Maksimum 1:3000`,
        list_3: `Komisen $3.5 `,
        list_4: `Minimum deposit 200 USD`,
      },
      standard_pro: `Berlabur dengan spread terendah. Pelaksanaan pesanan yang sangat baik, kegelinciran dikurangkan, requote mungkin berlaku jika harga pasaran berubah dengan cepat.`,
      list_pro: {
        list_1: `Spread dari 0.1 PIPs`,
        list_2: `Tiada Komisen`,
        list_3: `Minimum Deposit 1000 USD`,
        list_4: `Lot saiz minimum 0.1`,
      },
      btn: {
        real: `Buka akaun dagangan sebenar`,
        demo: `Cuba berdagang pada akaun demo`,
      },
    },
    aboutPage: {
      why_become: "Mengapa menjadi pasangan kami?",
      Our_in_house:
        "Agregator tempat dalaman kami dan teknologi pencocokan pesanan maju menyediakan peniaga kami dengan akses ke kolam kecairan yang mendalam dan pelaksanaan perdagangan ultra-cepat tanpa campur tangan meja berurusan supaya peniaga dapat mendapat manfaat daripada penyebaran ketat dan harga yang kompetitif.",
      our_history: {
        header: "SEJARAH KITA",
        detail:
          "Sejak penubuhan kami, pasaran IUX telah berjaya berkembang untuk melayani pelanggan runcit dan institusi di lebih daripada 170 negara - dan kami masih berkembang.",
        title_2:
          "IUX Markets Limited. Which is subject to supervision by the Securities Commission. Financial Services Authority Has allowed the business of financial services and number  T2023172 Registered Address:P.B. 1257 Bonovo Road, Fomboni, Comoros, KM. and the Grenadines and IUX Markets Limited. also registered with the National Futures Association (NFA) from United States which designated by the CFTC as a registered futures association. NFA strives everyday to safeguard the integrity of the derivatives markets, protect investors and ensure members meet their regulatory responsibilities.",
      },
      box_1: {
        des_1: `Pasaran IUX menawarkan perdagangan pada saham, indeks tempat, niaga hadapan, logam tempat dan tenaga tempat. Kami menyediakan pelanggan kami dengan akses kepada kecairan peringkat atas dan pelaksanaan perdagangan lanjutan tanpa campur tangan meja berurusan.`,
      },
      box_2: {
        des_1: `IUX Markets Limited, yang tertakluk kepada pengawasan oleh Suruhanjaya Sekuriti. Pihak Berkuasa Perkhidmatan Kewangan di Saint Vincent dan Grenadines telah membenarkan perniagaan perkhidmatan kewangan dan nombor `,
        des_2: `berdaftar di Beachmont Business Centre, 321, Kingstown, St. Vincent and the Grenadines dan IUX Markets Limited juga berdaftar dengan MWALI International Services Authority (Comoros) sebagai broker terkawal dan berlesen bagi sekuriti dagangan CFDs antarabangsa dengan nombor lesen `,
        des_3: `Selain itu, IUX Markets Limited berdaftar dengan pengawal selia perdagangan Persatuan Niaga Hadapan Nasional (NFA), yang menyelia broker derivatif dan niaga hadapan, `,
      },
      section_1: {
        title_1: `Latar Belakang Syarikat`,
        description_1: `IUX Markets telah ditubuhkan di London pada 2016 sebagai penyedia perkhidmatan dagangan CFDs secara online. Perjalanan proses dagangan pelanggan adalah sangat penting bagi kami. Oleh itu, kami berusaha untuk meningkatkan teknologi perkhidmatan yang sesuai dan mempelajari pelanggan. Selama lebih sedekad dimana industri dan harapan pelanggan berkembang secara berterusan malah kami dapat meletakkan kedudukan kami sebagai broker yang cekap dan stabil di `,
        title_2: `Perkhidmatan kami`,
        description_2: `IUX Markets kini menawarkan akaun dagangan spread dan komisen. Kami menawarkan lebih daripada 350 instrumen CFDs yang boleh didagangkan termasuk CFDs, Saham, Indeks dan Komoditi. kami diterima secara meluas sebagai broker MT4 pertama di UK, sejak itu kami telah menambahkan dagangan mudah alih MT4 dan platform web kami pada suite platform dagangan kami.`,
        title_3: `Visi kami`,
        description_3: `Kami berusaha menyasarkan diri  untuk menjadi pilihan pertama dalam  dagangan CFDs untuk pedagang yang bercita-cita tinggi dan berpengalaman. Kami sentiasa berusaha menyediakan pelanggan kami pengalaman dagangan terbaik secara berterusan melalui perkhidmatan pelanggan yang boleh dipercayai, harga yang telus, pelaksanaan dagangan kependaman rendah dan platform yang stabil.`,
        description_4: `We are committed to creating a dynamic
                    environment that equips traders with all the necessary tools
                    for their trading experience with the utmost respect for
                    them.`,
        title_5: `Our Strategy`,
        description_5: `At IUXMARKETS we evolve with the times. We aim to continuously refine our services to cater to the needs of traders in this highly dynamic industry.`,
      },
      section_2: {
        title: `Nilai Kami `,
        title_1: `Utamakan Pendekatan Pelanggan`,
        title_2: `Integriti dan Pematuhan Ketentuan`,
        title_3: `Inovasi`,
        description_1: `Kami berusaha menyasarkan diri  untuk menjadi pilihan pertama dalam  dagangan CFDs untuk pedagang yang bercita-cita tinggi dan berpengalaman. Kami sentiasa berusaha untuk menyediakan pelanggan kami pengalaman dagangan terbaik secara berterusan melalui perkhidmatan pelanggan yang boleh dipercayai, harga yang telus, pelaksanaan dagangan kependaman rendah dan platform yang stabil`,
        description_2: `Kami berusaha untuk menyediakan perkhidmatan yang telus, selamat dan boleh dipercayai kepada pelanggan kami.IUX Markets dilesenkan oleh  Broker CFDs St-Vincent license `,
        description_3: `IUX Markets komited untuk memastikan kelajuan pelaksanaan yang pantas, platform dagangan yang berkualiti dan transaksi yang selamat adalah standard minimum untuk pengalaman dagangan anda.`,
      },
      section_3: {
        title: `Peraturan`,
        description: `IUX Markets dikawal oleh  Broker CFDs St-Vincent license dan memegang Lesen sebagai ejen peniaga pelaburan (Discount Broker)`,
        sub_head_title_1: `Lokasi`,
        title_1: `United Kingdom`,
        title_2: ``,
        title_3: `Singapore`,
        description_1: `6-8 Revenge Road , Suite 2096 United Kingdom ME5 8UD Chatham, UK support@iuxmarket.com`,
        description_2: `P.B. 1257 Bonovo Road, Fomboni, Comoros, KM.`,
        description_3: `30 Paya Lebar Road, #01-37, Paya Lebar Square, Singapore 409051 support@iuxmarkets.com`,
      },
    },
  },
  id: {
    aboutMeTitle:
      "IUX Markets mulai meningkatkan tingkat perdagangan ke tingkat keamanan yang tinggi. Mengeksekusi setiap langkah cepat, kemajuan dengan alat perdagangan modern di pasar CFDs dan kami telah melihat banyak masalah perdagangan dan telah mengambil langkah-langkah untuk meningkatkan. Untuk memungkinkan pelanggan Mampu mengakses sistem perdagangan dan melakukan berbagai transaksi cepat dan aman. Kami menghargai komoditas setiap saat Dari mencurahkan waktu dan memahami pentingnya dunia Uang pasar yang berfluktuasi dengan cepat dan efisien. Setiap keputusan yang kita buat Tujuan adalah untuk memastikan bahwa pelanggan kami dan mitra bisnis, termasuk tim ahli kami, menghabiskan waktu dengan bijaksana. Kami percaya bahwa pengetahuan adalah kekuatan. Dan mendorong pedagang Mendapatkan hasil investasi terbaik adalah keinginan kami.",
    aboutMeIcon: {
      title_1: "standar keamanan kelas dunia",
      description_1:
        "Kami menjaga informasi keuangan Anda. Aman Dengan enkripsi dan pengawasan 24 jam sehari, hari tujuh minggu.",
      title_2: "penarikan cepat\n",
      description_2:
        "Kami menyadari bahwa deposito dan penarikan cepat dan mudah. Akan membantu pedagang untuk tidak melewatkan peluang perdagangan yang penting. Harus deposit - withdraw mudah, tidak rumit",
      title_3: "Masukkan pesan segera, tidak perlu menunggu antrian",
      description_3:
        "Misi kami adalah untuk memberikan layanan pedagang Untuk mendapatkan harga terbaik Kami berusaha keras dalam teknologi. Untuk meningkatkan likuiditas untuk pelanggan",
      title_4: "Kami bermitra dengan bank di seluruh dunia.\n",
      description_4:
        "Kami bekerja sama dengan bank domestik dan asing. Memungkinkan Anda untuk menerima kredit bonus dari penyetoran dana untuk meminimalkan risiko sebanyak mungkin.",
    },
    accept_policy: `Accept the terms and conditions`,
    policy_dashboard_1: `Dear Customers,\n\nThis only has an impact on stocks. Please note of the following updates if you trade stocks (CFDs).\n\nTrading by setting pending orders before the market opens is not possible.\n\nThe order will be invalidated or canceled.Only once the market opens can active orders be placed.As a result, group financial instruments are covered all Stocks (CFDs).\n\nPlease consider this information and make adjustments to your trading strategy in advance if necessary!\n\nBest Regards, IUX Markets Limited.`,
    accountType: {
      standard: `Top accounts with lowest spread No commissions Suitable for all types of trading For investors of all levels , No deposit and withdrawal fees`,
      list: {
        list_1: `Spread from 0.2 PIPs`,
        list_2: `Max Leverage 1:3000`,
        list_3: `No Commission`,
        list_4: `Minimum deposit 10 USD`,
      },
      cent: ` An account for beginner investors with fewer investment units Suitable for all types of trading`,
      list_cent: {
        list_1: `Spread from 0.2 PIPs`,
        list_2: `Max Leverage 1:3000`,
        list_3: `No Commission`,
        list_4: `Minimum deposit 10 USD`,
      },
      standard_bonus: `35% bonus account suitable for long term trading. No fees , No deposit and withdrawal fees`,
      list_bonus: {
        list_1: `Spread from 0.5 PIPs`,
        list_2: `Max Leverage 1:1000`,
        list_3: `35% Deposit Bonus`,
        list_4: `Minimum deposit 10 USD`,
      },
      standard_ecn: `VIP Investor account spread start from 0.0 PIPs, commission is just $ 3.5 only, No deposit and withdrawal fees`,
      list_ecn: {
        list_1: `Spread from 0.0 PIPs`,
        list_2: `Max Leverage 1:3000`,
        list_3: `$3.5 Commission`,
        list_4: `Minimum deposit 200 USD`,
      },
      standard_raw: `VIP Investor account spread start from 0.0 PIPs, commission is just $ 7 only, No deposit and withdrawal fees`,
      list_raw: {
        list_1: `Spread from 0.0 PIPs`,
        list_2: `Max Leverage 1:3000`,
        list_3: `$6 Commission`,
        list_4: `Minimum deposit 200 USD`,
      },
      standard_pro: `Trade with the lowest spread Excellent fill and reduced slippage. Requotes may happen in fast-moving markets`,
      list_pro: {
        list_1: `Spread 0.1 PIPs`,
        list_2: `No Commission`,
        list_3: `Minimum Deposit 1000 USD`,
        list_4: `0.1 Minimum  Lot size`,
      },
      btn: {
        real: `Open a real trading account`,
        demo: `Trading on a demo account`,
      },
    },
    aboutPage: {
      why_become: "Mengapa menjadi mitra kami?",
      Our_in_house:
        "Agregator spot in-house kami dan teknologi pencocokan pesanan lanjutan memberi para pedagang kami akses ke kumpulan likuiditas yang dalam dan eksekusi perdagangan yang sangat cepat tanpa intervensi meja berurusan sehingga pedagang dapat memperoleh manfaat dari penyebaran yang ketat dan harga kompetitif.",
      our_history: {
        header: "SEJARAH KITA",
        detail:
          "Sejak pendirian kami, IUX Markets telah berhasil berkembang untuk melayani klien ritel dan institusional di lebih dari 170 negara - dan kami masih tumbuh.",
        title_2:
          "IUX Markets Limited. Which is subject to supervision by the Securities Commission. Financial Services Authority Has allowed the business of financial services and number  T2023172 Registered Address:P.B. 1257 Bonovo Road, Fomboni, Comoros, KM. and the Grenadines and IUX Markets Limited. also registered with the National Futures Association (NFA) from United States which designated by the CFTC as a registered futures association. NFA strives everyday to safeguard the integrity of the derivatives markets, protect investors and ensure members meet their regulatory responsibilities.",
      },
      box_1: {
        des_1: `IUX Markets menawarkan perdagangan saham, indeks spot, futures, logam spot dan energi spot. Kami memberi klien kami akses ke likuiditas tingkat atas dan pelaksanaan perdagangan lanjutan tanpa intervensi meja berurusan.`,
      },
      box_2: {
        des_1: `IUX Markets Limited, yang tunduk pada pengawasan Komisi Sekuritas. Otoritas Jasa Keuangan di Saint Vincent dan Grenadines telah mengizinkan bisnis jasa keuangan dan nomor `,
        des_2: `, terdaftar di Pusat Bisnis Beachmont, 321, Kingstown, St. Vincent dan Grenadines dan IUX Markets Limited juga terdaftar di Otoritas Layanan Internasional MWALI ( Comoros) sebagai pialang sekuritas perdagangan CFDs internasional teregulasi dan berlisensi dengan nomor lisensi `,
        des_3: `Selain itu, IUX Markets Limited terdaftar di regulator perdagangan National Futures Association (NFA), yang mengawasi broker derivatif dan berjangka, `,
      },
      section_1: {
        title_1: `Company History`,
        description_1: `IUX Markets was established  in 2016 as a provider of online CFDs trading services. Our client’s trading journey is very important to us, and as such we are always committed in refining our technology, tailored services and client education. For over a decade, as the industry and clients’ expectations keep evolving, we have positioned ourselves firmly as a trusted and leading  regulated broker.`,
        title_2: `Our Services`,
        description_2: `IUX Markets currently offers a spread-based and a commission-based trading account. We have more than 350 tradeable CFDs instruments including CFDs, Shares, Indices and Commodities. Widely recognised as the first MT4 broker in United Kingdom, we have since added MT4,mobile trading and a web-based platform to our suite of trading platforms.`,
        title_3: `Our Vision`,
        description_3: `We strive to be the first choice for trading CFDs for aspiring and experienced traders. We strive to continuously provide the best trading experience to our clients through reliable customer service, transparent pricing, low-latency trade execution and platform stability.`,
        description_4: `We are committed to creating a dynamic
                    environment that equips traders with all the necessary tools
                    for their trading experience with the utmost respect for
                    them.`,
        title_5: `Our Strategy`,
        description_5: `At IUXMARKETS we evolve with the times. We aim to continuously refine our services to cater to the needs of traders in this highly dynamic industry.`,
      },
      section_2: {
        title: `Our Values`,
        title_1: `Client-first approach`,
        title_2: `Integrity and Compliance`,
        title_3: `Innovation`,
        description_1: `We strive to be the first choice for trading CFDs for aspiring and experienced traders. We strive to continuously provide the best trading experience to our clients through reliable customer service, transparent pricing, low-latency trade execution and platform stability.`,
        description_2: `We endeavour to provide clients with transparent, secure and reliable services. IUX Markets is licensed by the St-Vincent CFDs Broker License `,
        description_3: `IUX Markets is dedicated to ensuring fast execution speed, quality trading platforms and secure transactions as a minimum standard for your trading experience.`,
      },
      section_3: {
        title: `Regulation`,
        description: `IUX Markets is regulated by the St-Vincent CFDs Broker License  and is a holder of an Investment Dealer (Discount Broker)`,
        sub_head_title_1: `Locations`,
        title_1: `United Kingdom`,
        title_2: ``,
        title_3: `Singapore`,
        description_1: `6-8 Revenge Road , Suite 2096 United Kingdom ME5 8UD Chatham, UK support@iuxmarket.com`,
        description_2: `P.B. 1257 Bonovo Road, Fomboni, Comoros, KM.`,
        description_3: `30 Paya Lebar Road, #01-37, Paya Lebar Square, Singapore 409051 support@iuxmarkets.com`,
      },
    },
  },
  zh: {
    aboutMeTitle:
      "IUX Markets开始交易的水平提高到一个很高的安全级别。快速执行的每一步，在外汇市场现代交易手段进步，我们已经看到了许多贸易问题，并已采取步骤改善。为了让客户能够访问交易系统和快速，安全地进行各种交易。我们重视在任何时候都从商品投入的时间和理解是浮动的快速，高效地货币市场的世界的重要性。我们做出客观的每一个决定是为了确保我们的客户和业务合作伙伴，包括我们的专家团队，花时间明智。我们认为，知识就是力量。并鼓励交易商获得最佳的投资效果是我们的愿望",
    aboutMeIcon: {
      title_1: "世界一流的安全标准",
      description_1:
        "我们会确保您的财务信息。安全加密和监控，每天24小时，每周七天",
      title_2: "快速撤离\n",
      description_2:
        "我们都知道，存款和取款是方便快捷。将帮助交易者不会错过重要的贸易机会。必须存入 - 退出容易，不复杂",
      title_3: "输入立即命令，无需等待队列",
      description_3:
        "我们的使命是为贸易商提供服务，以获得最好的价格，我们努力在技术。为了增加流动性的客户 ",
      title_4: "与世界各地的银行，我们的合作伙伴。“，\n",
      description_4:
        "我们与国内和外资银行合作。让您可以从存入资金的风险降到最低，尽可能获得奖励学分",
    },
    aboutPage: {
      why_become: "為什麼要成為我們的伴侶？",
      Our_in_house:
        "我們的內部現貨聚合器和高級訂單匹配技術為我們的貿易商提供了深厚的流動性池和超快速的貿易執行，而無需交易台式乾預，以便交易者可以從嚴格的價差和競爭性定價中受益。",
      our_history: {
        header: "我們的歷史",
        detail:
          "自我們建立以來，IUX市場已成功擴展，為170多個國家 /地區的零售和機構客戶提供服務 - 我們仍在增長。",
        title_2:
          "IUX Markets Limited. Which is subject to supervision by the Securities Commission. Financial Services Authority Has allowed the business of financial services and number  T2023172 Registered Address:P.B. 1257 Bonovo Road, Fomboni, Comoros, KM. and the Grenadines and IUX Markets Limited. also registered with the National Futures Association (NFA) from United States which designated by the CFTC as a registered futures association. NFA strives everyday to safeguard the integrity of the derivatives markets, protect investors and ensure members meet their regulatory responsibilities.",
      },
      box_1: {
        des_1: `IUX Markets提供股票，現貨指數，期貨，現貨金屬和現貨能量的交易。我們為客戶提供了訪問頂級流動性和高級貿易執行的訪問，而無需交易桌子乾預。`,
      },
      box_2: {
        des_1: `IUX Markets Limited，受證監會監管。 聖文森特和格林納丁斯金融服務管理局已允許金融服務業務，編號為`,
        des_2: `，註冊地址為 Beachmont Business Centre, 321, Kingstown, St. Vincent and the Grenadines，IUX Markets Limited 也在 MWALI 國際服務管理局註冊（ Comoros）作為國際差價合約交易證券的受監管和許可經紀人，許可證號為`,
        des_3: `此外，IUX Markets Limited 在美國國家期貨協會（NFA）交易監管機構註冊，該監管機構監管衍生品和期貨經紀商 `,
      },
      section_1: {
        title_1: `Company History`,
        description_1: `IUX Markets was established  in 2016 as a provider of online CFDs trading services. Our client’s trading journey is very important to us, and as such we are always committed in refining our technology, tailored services and client education. For over a decade, as the industry and clients’ expectations keep evolving, we have positioned ourselves firmly as a trusted and leading  regulated broker.`,
        title_2: `Our Services`,
        description_2: `IUX Markets currently offers a spread-based and a commission-based trading account. We have more than 350 tradeable CFDs instruments including CFDs, Shares, Indices and Commodities. Widely recognised as the first MT4 broker in United Kingdom, we have since added MT4,mobile trading and a web-based platform to our suite of trading platforms.`,
        title_3: `Our Vision`,
        description_3: `We strive to be the first choice for trading CFDs for aspiring and experienced traders. We strive to continuously provide the best trading experience to our clients through reliable customer service, transparent pricing, low-latency trade execution and platform stability.`,
        description_4: `We are committed to creating a dynamic
                    environment that equips traders with all the necessary tools
                    for their trading experience with the utmost respect for
                    them.`,
        title_5: `Our Strategy`,
        description_5: `At IUXMARKETS we evolve with the times. We aim to continuously refine our services to cater to the needs of traders in this highly dynamic industry.`,
      },
      section_2: {
        title: `Our Values`,
        title_1: `Client-first approach`,
        title_2: `Integrity and Compliance`,
        title_3: `Innovation`,
        description_1: `We strive to be the first choice for trading CFDs for aspiring and experienced traders. We strive to continuously provide the best trading experience to our clients through reliable customer service, transparent pricing, low-latency trade execution and platform stability.`,
        description_2: `We endeavour to provide clients with transparent, secure and reliable services. IUX Markets is licensed by the St-Vincent CFDs Broker License `,
        description_3: `IUX Markets is dedicated to ensuring fast execution speed, quality trading platforms and secure transactions as a minimum standard for your trading experience.`,
      },
      section_3: {
        title: `Regulation`,
        description: `IUX Markets is regulated by the St-Vincent CFDs Broker License  and is a holder of an Investment Dealer (Discount Broker)`,
        sub_head_title_1: `Locations`,
        title_1: `United Kingdom`,
        title_2: ``,
        title_3: `Singapore`,
        description_1: `6-8 Revenge Road , Suite 2096 United Kingdom ME5 8UD Chatham, UK support@iuxmarket.com`,
        description_2: `P.B. 1257 Bonovo Road, Fomboni, Comoros, KM.`,
        description_3: `30 Paya Lebar Road, #01-37, Paya Lebar Square, Singapore 409051 support@iuxmarkets.com`,
      },
    },
    accept_policy: `Accept the terms and conditions`,
    policy_dashboard_1: `尊敬的客戶，\n\n這僅適用於股票。如果您正在交易 （Stock CFD），請注意以下即將發生的變化。\n\n在開市前設置掛單進行交易是不可能的。\n\n此訂單將被取消或作廢。只有在市場開盤後才能下有效訂單。\n\n因此，這適用於所有分組金融工具 （Stock CFD）。\n\n\n請考慮這些信息並在必要時提前調整您的交易策略！謝謝你，祝你一周愉快\n\n\n此致，IUX Markets Limited。`,
  },
  vi: {
    aboutMeTitle: `IUX Markets được xây dựng để tăng cường giao dịch có mức độ bảo mật cao, thực hiện tiến bộ nhanh chóng,cùng với các công cụ giao dịch hiện đại nhất trên thị trường ngoại hối và chúng tôi đã thấy rất nhiều vấn đề giao dịch và đã khắc phục tốt hơn, để khách hàng có thể truy cập vào hệ thống giao dịch và thực hiện các giao dịch một cách nhanh chóng và an toàn. Chúng tôi luôn coi trọng những hàng hóa có giá trị và dành thời gian để được tầm quan trọng của Thị trường tiền tệ thế giới nhanh chóng và hiệu quả, tất cả quyết mà chúng tôi đã làm có mục đích để chắc chắn rằng khách hàng và đối tác kinh doanh của chúng tôi bao gồm nhóm chuyên gia đã sử dụng thời gian một cách khôn ngoan. Chúng tôi tin rằng kiến ​​thức là sức mạnh. và khuyến khích các nhà giao dịch Đạt được kết quả đầu tư tốt nhất là yêu cầu của chúng tôi. `,
    aboutMeIcon: {
      title_1: "An toàn tiêu chuẩn toàn cầu",
      description_1:
        "Chúng tôi giữ thông tin tài chính của bạn một cách an toàn với mã hóa 24/7 và giám sát gian lận",
      title_2: "Nạp và rút tiền nhanh chóng và ổn định",
      description_2:
        "Chúng tôi nhận thấy rằng việc nạp và rút tiền mà  và nhanh chóng. sẽ giúp các nhà giao dịch không bỏ lỡ các cơ hội giao dịch,  quan trọng là phải rút tiền dễ dàng, không phức tạp ",
      title_3: "Giao dịch ngay lập tức mà không cần phải xếp hàng chờ đợi.",
      description_3:
        "Sứ mệnh của chúng tôi ​là phục vụ các nhà giao dịch. để có giá tốt nhất Chúng tôi rất cố gắng trong lĩnh vực công nghệ. để tăng tính thanh khoản cho khách hàng",
      title_4: "Chúng tôi hợp tác với các ngân hàng trên thế giới",
      description_4:
        "Chúng tôi hợp tác với ngân hàng trong nước và quốc tế. Cho phép bạn nhận tiền thưởng tín dụng khi gửi tiền để giảm thiểu rủi ro nhiều nhất có thể",
    },
    accept_policy: `Chấp nhận các điều khoản và điều kiện`,
    policy_dashboard_1: `Kính thưa khách hàng thân mếm, điều này chỉ áp dụng nhóm cổ phiếu, nếu bạn đang Stock(CFDs) ้ãy lưu ý những thay đổi sắp gây ra sau đây.\n\n Việc giao dịch bằng cách đặt Pending order chờ trước khi thị trường mở cửa sẽ không thể làm được, Đơn đặt hàng này sẽ bị hủy hoặc vô hiệu\n\n các lệnh có hiệu lực sẽ xảy ra sau khi thị trường mở cửa.\n\nĐiều này áp dụng cho các công cụ tài chính tập đoàn Stock(CFDs)tất cả\n\nVui lòng xem xét thông tin này và điều chỉnh chiến lược giao dịch của bạn trước nếu cần!\n\ncảm ơn và là tuần tuyệt vời!, Trân trọng IUX Markets Limited`,

    aboutPage: {
      why_become: "Tại sao trở thành đối tác của chúng tôi?",
      Our_in_house:
        "Công cụ tổng hợp tại chỗ của chúng tôi và công nghệ khớp đơn hàng nâng cao cung cấp cho các nhà giao dịch của chúng tôi quyền truy cập vào nhóm thanh khoản sâu và thực hiện thương mại cực nhanh mà không có sự can thiệp của bàn giao dịch để các nhà giao dịch có thể hưởng lợi từ việc lây lan chặt chẽ và giá cả cạnh tranh.",
      our_history: {
        header: "Lịch sử của chúng tôi",
        detail:
          "Kể từ khi thành lập của chúng tôi, thị trường IUX đã mở rộng thành công để phục vụ các khách hàng bán lẻ và tổ chức tại hơn 170 quốc gia - và chúng tôi vẫn đang phát triển.",
        title_2:
          "IUX Markets Limited. Which is subject to supervision by the Securities Commission. Financial Services Authority Has allowed the business of financial services and number  T2023172 Registered Address:P.B. 1257 Bonovo Road, Fomboni, Comoros, KM. and the Grenadines and IUX Markets Limited. also registered with the National Futures Association (NFA) from United States which designated by the CFTC as a registered futures association. NFA strives everyday to safeguard the integrity of the derivatives markets, protect investors and ensure members meet their regulatory responsibilities.",
      },
      section_1: {
        title_1: `Công ty`,
        description_1: `IUX Markets Được thành lập tại London vào năm 2016, là nhà cung cấp giao dịch CFDs trực tuyến. Hành trình giao dịch của khách hàng rất quan trọng đối với chúng tôi vì điều này chúng tôi nên cố gắng cải tiến công nghệ dịch vụ phù hợp và tìm hiểu khách hàng hơn một thập kỷ, ngành công nghiệp và kỳ vọng của khách hàng đã phát triển theo thời gian. Chúng tôi đã định vị vững chắc mình là một nhà môi giới được quản lý tại Vương quốc Anh`,
        title_2: `Dịch vụ của chúng tôi`,
        description_2: `Hiện tại IUX Markets Có tài khoản giao dịch spread và hoa hồng, chúng tôi có công cụ nhiều hơn 350 mà có thể thay đổi, bao gồm CFDs, Cổ phiếu, Chỉ số và Hàng hóa. Được chấp nhận rộng rãi là đầu tiên nhà môi giới MT4 Ở Vương quốc Anh kể từ đó, chúng tôi đã thêm nền tảng web và giao dịch di động MT4 vào bộ nền tảng giao dịch của mình`,
        title_3: `Tầm nhìn của chúng tôi`,
        description_3: `Chúng tôi cố gắng trở thành sự lựa chọn đầu tiên của bạn để giao dịch CFDs đối với nhà giao dịch đã cần và có kinh nghiệm,  Chúng tôi không ngừng nỗ lực mang đến cho khách hàng trải nghiệm giao dịch tốt nhất có thể thông qua dịch vụ khách hàng đáng tin cậy, giá cả minh bạch, thực hiện giao dịch có độ trễ thấp và tính ổn định của nền tảng.`,
        description_4: `We are committed to creating a dynamic
                    environment that equips traders with all the necessary tools
                    for their trading experience with the utmost respect for
                    them.`,
        title_5: `Our Strategy`,
        description_5: `At IUXMARKETS we evolve with the times. We aim to continuously refine our services to cater to the needs of traders in this highly dynamic industry.`,
      },
      section_2: {
        title: `giá trị của chúng tôi`,
        title_1: `Nguyên tắckhách hàng đầu tiên`,
        title_2: `trung thực và thực hiện theo quy định.`,
        title_3: `sự đổi mới`,
        description_1: `Chúng tôi mong muốn trở thành sự lựa chọn đầu tiên cho giao dịch CFDs đối với các nhà giao dịch đầy tham vọng và giàu kinh nghiệm, Chúng tôi không ngừng nỗ lực mang đến cho khách hàng trải nghiệm giao dịch tốt nhất có thể thông qua dịch vụ khách hàng đáng tin cậy, giá cả minh bạch, thực hiện giao dịch có độ trễ thấp và tính ổn định của nền tảng.`,
        description_2: `Chúng tôi cố gắng cung cấp các dịch vụ minh bạch, an toàn và đáng tin cậy cho khách hàng. IUX Markets được phép từ St-Vincent CFDs Broker License `,
        description_3: `IUX Markets Cố gắng tạo sự tin cậy thực hiện với việc  tốc độ nhanh chóng, Trên nền tảng giao dịch chất lượng và giao dịch an toàn là những tiêu chuẩn tối thiểu cho trải nghiệm giao dịch của bạn.`,
      },
      section_3: {
        title: `guy định`,
        description: `Thị trường IUX trong dưới kiểm soát bởi Giấy phép Nhà môi giới  St-Vincent CFDs và là người có giấy phép đại lý đầu tư (Discount Broker)`,
        sub_head_title_1: `Địa điểm`,
        title_1: `United Kingdom`,
        title_2: ``,
        title_3: `Singapore`,
        description_1: `6-8 Revenge Road, Suite 2096 United Kingdom ME5 8UD Chatham, UK support@iuxmarket.com`,
        description_2: `P.B. 1257 Bonovo Road, Fomboni, Comoros, KM.`,
        description_3: `30 Paya Lebar Road, #01-37, Paya Lebar Square, Singapore 409051 support@iuxmarkets.com`,
      },
    },

    accountType: {
      standard: `Tài khoản hàng đầu, chênh lệch thấp nhất. Không có hoa hồng. Thích hợp với mọi loại hình giao dịch. Dành cho các nhà đầu tư ở mọi cấp độ. Không có phí nạp rút tiền.`,
      list: {
        list_1: `Spread 0.2 PIPs`,
        list_2: `Leverage tối đa 1:3000`,
        list_3: `No Swap`,
        list_4: `Số nạp tiền tối thiểu $10`,
      },
      cent: `Tài khoản dành cho các nhà đầu tư mới bắt đầu với số lượng đơn vị đầu tư ít hơn Phù hợp với mọi loại hình giao dịch `,
      list_cent: {
        list_1: `Spread 0.2 PIPs`,
        list_2: `Leverage tối đa 1:3000`,
        list_3: `No Swap`,
        list_4: `Số nạp tiền tối thiểu $10`,
      },
      standard_bonus: `Tài khoản bonus 35% phụ hợp với việc giao dịch thời gian dài. Không mất chi phí.`,
      list_bonus: {
        list_1: `Spread 0.5 PIPs`,
        list_2: `Leverage tối đa 1:1000`,
        list_3: `Tiền thưởng nạp tiền 35%`,
        list_4: `Số nạp tiền tối thiểu $10`,
      },
      standard_ecn: `Tài khoản nhà đầu tư VIP Spread thấp bắt đầu 0.0 PIPs. Chi phí $3.5/Lot. Phí nạp và rút tiền miễn phí.`,
      list_ecn: {
        list_1: `Spread 0.0 PIPs`,
        list_2: `Leverage tối đa 1:3000`,
        list_3: `Phí $3.5/Lot`,
        list_4: `Số nạp tiền tối thiểu $200`,
      },
      standard_raw: `Tài khoản nhà đầu tư VIP Spread thấp bắt đầu 0.0 PIPs. Chi phí $6/Lot. Phí nạp và rút tiền miễn phí.`,
      list_raw: {
        list_1: `Spread 0.0 PIPs`,
        list_2: `Leverage tối đa 1:3000`,
        list_3: `Phí $6/Lot`,
        list_4: `Số nạp tiền tối thiểu $600`,
      },
      standard_pro: `Giao dịch với Spread thấp nhất, Thực hiện giao dịch tuyệt vời, giảm slippage có thể có Requotes nếu giá thị trường thay đổi nhanh chóng.`,
      list_pro: {
        list_1: `Spread 0.1 PIPs`,
        list_2: `Không có hoa hồng`,
        list_3: `Số nạp tiền tối thiểu 1000 USD`,
        list_4: `tối thiểu 0.1 Lot size`,
      },
      btn: {
        real: `Mở tài khoản giao dịch thực`,
        demo: `Thử giao dịch trên tài khoản demo`,
      },
    },
  },
  ko: {
    aboutMeTitle:
      "IUX Markets는 높은 수준의 보안에 거래의 수준을 높이려면 시작했다. 외환 시장에 현대적인 거래 도구를 진행, 빨리 모든 단계를 실행하고 우리는 많은 거래 문제를 보았다하고 개선하기위한 조치를 취했습니다. 거래 시스템에 액세스하고 신속하고 안전하게 다양한 거래를 수행 할 수 고객을 허용합니다. 우리는 시간을 할애하고 신속하고 효율적으로 변동이 금융 시장의 세계의 중요성을 이해에서 항상 상품의 가치. 우리가 목적 만드는 모든 결정은 고객과 전문가 팀을 포함하여 비즈니스 파트너, 현명하게 시간을 보낼 수 있도록하는 것입니다. 우리는 아는 것이 힘이라고 생각합니다. 그리고 우리의 욕망을 가장 좋은 투자 결과입니다 얻기 상인을 격려.",
    aboutMeIcon: {
      title_1: "세계 수준의 안전 기준 ",
      description_1:
        "우리는 당신의 금융 정보를 유지한다. 안전하게 암호화 및 감시 하루 24 시간, 일주일 내내. ",
      title_2: "빠른 철수 \n",
      description_2: `우리는 예금과 인출을 빠르고 쉽게 것을 알고 있습니다. 중요한 무역 기회를 놓치지 상인을하지 도움이 될 것입니다. 입금해야합니다 - '쉽게, 복잡하지, 철회`,
      title_3: `'즉시 명령을 입력 필요 '큐 대기하지 않으려면'`,
      description_3: `우리의 임무는 우리는 기술 열심히 노력 최고의 가격을 얻으려면 상인 서비스를 제공하는 것입니다. '고객을위한 유동성을 증가시키기 위해 `,
      title_4: `세계 은행과 우리 파트너.\n`,
      description_4: `우리는 국내 및 외국 은행들과 협력한다. 당신은 가능한 한 위험을 최소화하기 위해 자금을 입금 보너스 크레딧을받을 수 있도록 허용.`,
    },
    accept_policy: `Accept the terms and conditions`,
    policy_dashboard_1: `Dear Customers,\n\nThis only has an impact on stocks. Please note of the following updates if you trade stocks (CFDs).\n\nTrading by setting pending orders before the market opens is not possible.\n\nThe order will be invalidated or canceled.Only once the market opens can active orders be placed.As a result, group financial instruments are covered all Stocks (CFDs).\n\nPlease consider this information and make adjustments to your trading strategy in advance if necessary!\n\nBest Regards, IUX Markets Limited.`,
    accountType: {
      standard: `Top accounts with lowest spread No commissions Suitable for all types of trading For investors of all levels , No deposit and withdrawal fees`,
      list: {
        list_1: `Spread from 0.2 PIPs`,
        list_2: `Max Leverage 1:3000`,
        list_3: `No Commission`,
        list_4: `Minimum deposit 10 USD`,
      },
      cent: `An account for beginner investors with fewer investment units Suitable for all types of trading `,
      list_cent: {
        list_1: `Spread from 0.2 PIPs`,
        list_2: `Max Leverage 1:3000`,
        list_3: `No Commission`,
        list_4: `Minimum deposit 10 USD`,
      },
      standard_bonus: `35% bonus account suitable for long term trading. No fees , No deposit and withdrawal fees`,
      list_bonus: {
        list_1: `Spread from 0.5 PIPs`,
        list_2: `Max Leverage 1:1000`,
        list_3: `35% Deposit Bonus`,
        list_4: `Minimum deposit 10 USD`,
      },
      standard_ecn: `VIP Investor account spread start from 0.0 PIPs, commission is just $ 3.5 only, No deposit and withdrawal fees`,
      list_ecn: {
        list_1: `Spread from 0.0 PIPs`,
        list_2: `Max Leverage 1:3000`,
        list_3: `$3.5 Commission`,
        list_4: `Minimum deposit 200 USD`,
      },
      standard_raw: `VIP Investor account spread start from 0.0 PIPs, commission is just $ 7 only, No deposit and withdrawal fees`,
      list_raw: {
        list_1: `Spread from 0.0 PIPs`,
        list_2: `Max Leverage 1:3000`,
        list_3: `$6 Commission`,
        list_4: `Minimum deposit 200 USD`,
      },
      standard_pro: `Trade with the lowest spread Excellent fill and reduced slippage. Requotes may happen in fast-moving markets`,
      list_pro: {
        list_1: `Spread 0.1 PIPs`,
        list_2: `No Commission`,
        list_3: `Minimum Deposit 1000 USD`,
        list_4: `0.1 Minimum  Lot size`,
      },
      btn: {
        real: `Open a real trading account`,
        demo: `Trading on a demo account`,
      },
    },
    aboutPage: {
      our_history: {
        title_2:
          "IUX Markets Limited. Which is subject to supervision by the Securities Commission. Financial Services Authority Has allowed the business of financial services and number  T2023172 Registered Address:P.B. 1257 Bonovo Road, Fomboni, Comoros, KM. and the Grenadines and IUX Markets Limited. also registered with the National Futures Association (NFA) from United States which designated by the CFTC as a registered futures association. NFA strives everyday to safeguard the integrity of the derivatives markets, protect investors and ensure members meet their regulatory responsibilities.",
      },
      box_1: {
        des_1: `IUX Markets는 주식, 스팟 지수, 선물, 스팟 메탈 및 스팟 에너지에 대한 거래를 제공합니다. 우리는 고객에게 책상 개입없이 최상위 유동성 및 고급 거래 실행에 대한 액세스를 제공합니다.`,
      },
      box_2: {
        des_1: `증권위원회의 감독을 받는 IUX Markets Limited. 세인트 빈센트 그레나딘의 금융 서비스 당국은 Beachmont Business Centre, 321, Kingstown, St. Vincent 및 Grenadines에 등록된`,
        des_2: `번의 금융 서비스 사업을 허용했으며 IUX Markets Limited도 MWALI 국제 서비스 기관에 등록했습니다( Comoros)는 라이선스 번호가  `,
        des_3: `인 국제 CFDs 거래 유가 증권의 규제 및 라이선스 브로커입니다.`,
      },
      section_1: {
        title_1: `Company History`,
        description_1: `IUX Markets was established  in 2016 as a provider of online CFDs trading services. Our client’s trading journey is very important to us, and as such we are always committed in refining our technology, tailored services and client education. For over a decade, as the industry and clients’ expectations keep evolving, we have positioned ourselves firmly as a trusted and leading  regulated broker.`,
        title_2: `Our Services`,
        description_2: `IUX Markets currently offers a spread-based and a commission-based trading account. We have more than 350 tradeable CFDs instruments including CFDs, Shares, Indices and Commodities. Widely recognised as the first MT4 broker in United Kingdom, we have since added MT4,mobile trading and a web-based platform to our suite of trading platforms.`,
        title_3: `Our Vision`,
        description_3: `We strive to be the first choice for trading CFDs for aspiring and experienced traders. We strive to continuously provide the best trading experience to our clients through reliable customer service, transparent pricing, low-latency trade execution and platform stability.`,
        description_4: `We are committed to creating a dynamic
                    environment that equips traders with all the necessary tools
                    for their trading experience with the utmost respect for
                    them.`,
        title_5: `Our Strategy`,
        description_5: `At IUXMARKETS we evolve with the times. We aim to continuously refine our services to cater to the needs of traders in this highly dynamic industry.`,
      },
      section_2: {
        title: `Our Values`,
        title_1: `Client-first approach`,
        title_2: `Integrity and Compliance`,
        title_3: `Innovation`,
        description_1: `We strive to be the first choice for trading CFDs for aspiring and experienced traders. We strive to continuously provide the best trading experience to our clients through reliable customer service, transparent pricing, low-latency trade execution and platform stability.`,
        description_2: `We endeavour to provide clients with transparent, secure and reliable services. IUX Markets is licensed by the St-Vincent CFDs Broker License `,
        description_3: `IUX Markets is dedicated to ensuring fast execution speed, quality trading platforms and secure transactions as a minimum standard for your trading experience.`,
      },
      section_3: {
        title: `Regulation`,
        description: `IUX Markets is regulated by the St-Vincent CFDs Broker License  and is a holder of an Investment Dealer (Discount Broker)`,
        sub_head_title_1: `Locations`,
        title_1: `United Kingdom`,
        title_2: ``,
        title_3: `Singapore`,
        description_1: `6-8 Revenge Road , Suite 2096 United Kingdom ME5 8UD Chatham, UK support@iuxmarket.com`,
        description_2: `P.B. 1257 Bonovo Road, Fomboni, Comoros, KM.`,
        description_3: `30 Paya Lebar Road, #01-37, Paya Lebar Square, Singapore 409051 support@iuxmarkets.com`,
      },
    },
  },
  fil: {
    aboutMeTitle: `IUX Markets nagsimula na itaas ang antas ng kalakalan sa isang mataas na antas ng seguridad. Ipatupad ang bawat hakbang nang mabilis, progreso na may mga modernong mga tool sa kalakalan sa CFDs market at kami ay nakakakita ng maraming mga problema kalakalan at kinuha mga hakbang upang mapabuti. Upang payagan ang mga customer Magagawang upang ma-access ang sistema ng kalakalan at pag-uugali ng iba't-ibang mga transaksyon nang mabilis at ligtas. Pinahahalagahan namin ang mga kalakal sa lahat ng oras mula sa paglalaan ng oras at pag-unawa sa kahalagahan ng mundo ng Money merkado na magbago nang mabilis at mahusay. Ang bawat desisyon na ginawa namin Ang layunin ay upang matiyak na ang aming mga customer at mga kasosyo sa negosyo, kabilang ang aming koponan ng mga dalubhasa, magpalipas ng oras nang matalino. Naniniwala kami na kaalaman ay kapangyarihan. At paghikayat sa mga mangangalakal Pagkuha ng pinakamahusay na mga resulta sa pamumuhunan ay ang aming pagnanais.`,
    aboutMeIcon: {
      title_1: `World class na kaligtasan ng mga pamantayan `,
      description_1: `Panatilihin namin ang iyong impormasyon sa pananalapi. Ligtas Sa pamamagitan ng pag-encrypt at surveillance 24 oras sa isang araw, pitong araw sa isang linggo.`,
      title_2: `Mabilis na withdrawal\n`,
      description_2: `Alam namin na deposito at withdrawals ay mabilis at madali. Ay makakatulong sa mga mangangalakal na hindi makaligtaan ang mga mahahalagang pagkakataon sa pangangalakal. Dapat magdeposito - withdraw madali, hindi kumplikado`,
      title_3: `Ipasok ang pagkakasunod-sunod agad, hindi na kailangang maghintay para sa mga pila`,
      description_3: `Ang aming misyon ay upang magbigay ng mga mangangalakal serbisyo Upang makuha ang pinakamahusay na presyo subukan kaming nagtatrabaho sa teknolohiya. Upang dagdagan ang pagkatubig para sa mga customer`,
      title_4: "Kami kasosyo na may mga bangko sa buong mundo.\n",
      description_4: `tumulong kami sa mga lokal at dayuhang mga bangko. Na nagpapahintulot sa iyo upang makatanggap ng bonus credits mula sa pagdedeposito ng mga pondo upang i-minimize ang panganib hangga't maaari. `,
    },
    accept_policy: `Accept the terms and conditions`,
    policy_dashboard_1: `Dear Customers,\n\nThis only has an impact on stocks. Please note of the following updates if you trade stocks (CFDs).\n\nTrading by setting pending orders before the market opens is not possible.\n\nThe order will be invalidated or canceled.Only once the market opens can active orders be placed.As a result, group financial instruments are covered all Stocks (CFDs).\n\nPlease consider this information and make adjustments to your trading strategy in advance if necessary!\n\nBest Regards, IUX Markets Limited.`,
    accountType: {
      standard: `Top accounts with lowest spread No commissions Suitable for all types of trading For investors of all levels , No deposit and withdrawal fees`,
      list: {
        list_1: `Spread from 0.2 PIPs`,
        list_2: `Max Leverage 1:3000`,
        list_3: `No Commission`,
        list_4: `Minimum deposit 10 USD`,
      },
      cent: `An account for beginner investors with fewer investment units Suitable for all types of trading `,
      list_cent: {
        list_1: `Spread from 0.2 PIPs`,
        list_2: `Max Leverage 1:3000`,
        list_3: `No Commission`,
        list_4: `Minimum deposit 10 USD`,
      },
      standard_bonus: `35% bonus account suitable for long term trading. No fees , No deposit and withdrawal fees`,
      list_bonus: {
        list_1: `Spread from 0.5 PIPs`,
        list_2: `Max Leverage 1:1000`,
        list_3: `35% Deposit Bonus`,
        list_4: `Minimum deposit 10 USD`,
      },
      standard_ecn: `VIP Investor account spread start from 0.0 PIPs, commission is just $ 3.5 only, No deposit and withdrawal fees`,
      list_ecn: {
        list_1: `Spread from 0.0 PIPs`,
        list_2: `Max Leverage 1:3000`,
        list_3: `$3.5 Commission`,
        list_4: `Minimum deposit 200 USD`,
      },
      standard_raw: `VIP Investor account spread start from 0.0 PIPs, commission is just $ 7 only, No deposit and withdrawal fees`,
      list_raw: {
        list_1: `Spread from 0.0 PIPs`,
        list_2: `Max Leverage 1:3000`,
        list_3: `$6 Commission`,
        list_4: `Minimum deposit 200 USD`,
      },
      standard_pro: `Trade with the lowest spread Excellent fill and reduced slippage. Requotes may happen in fast-moving markets`,
      list_pro: {
        list_1: `Spread 0.1 PIPs`,
        list_2: `No Commission`,
        list_3: `Minimum Deposit 1000 USD`,
        list_4: `0.1 Minimum  Lot size`,
      },
      btn: {
        real: `Open a real trading account`,
        demo: `Trading on a demo account`,
      },
    },
    aboutPage: {
      why_become: "Bakit naging kapareha natin?",
      Our_in_house:
        "Ang aming in-house spot aggregator at advanced na teknolohiya na tumutugma sa order ay nagbibigay ng aming mga negosyante ng pag-access sa isang malalim na pool ng pagkatubig at ultra-mabilis na pagpapatupad ng kalakalan na walang pakikitungo sa interbensyon sa desk upang ang mga mangangalakal ay makikinabang mula sa masikip na pagkalat at mapagkumpitensyang pagpepresyo.",
      our_history: {
        header: "Ang aming kasaysayan",
        detail:
          "Mula pa sa aming pagtatatag, ang mga IUX Markets ay matagumpay na lumawak upang maghatid ng mga kliyente ng tingian at institusyonal sa higit sa 170 mga bansa - at lumalaki pa rin tayo.",

        title_2:
          "IUX Markets Limited. Which is subject to supervision by the Securities Commission. Financial Services Authority Has allowed the business of financial services and number  T2023172 Registered Address:P.B. 1257 Bonovo Road, Fomboni, Comoros, KM. and the Grenadines and IUX Markets Limited. also registered with the National Futures Association (NFA) from United States which designated by the CFTC as a registered futures association. NFA strives everyday to safeguard the integrity of the derivatives markets, protect investors and ensure members meet their regulatory responsibilities.",
      },
      box_1: {
        des_1: `"Nag -aalok ang Iux Markets ng pangangalakal sa mga pagbabahagi, mga indeks ng lugar, futures, spot metal at energies ng spot. Nagbibigay kami ng aming mga kliyente ng pag-access sa top-tier na pagkatubig at advanced na pagpapatupad ng kalakalan na walang pakikitungo sa interbensyon sa desk.`,
      },
      box_2: {
        des_1: `IUX Markets Limited, na napapailalim sa pangangasiwa ng Securities Commission. Pinahintulutan ng Financial Services Authority sa Saint Vincent and the Grenadines ang negosyo ng mga serbisyong pinansyal at numerong`,
        des_2: `, na nakarehistro sa Beachmont Business Center, 321, Kingstown, St. Vincent and the Grenadines at IUX Markets Limited na nakarehistro din sa MWALI International Services Authority (Comoros) bilang isang regulated at lisensyadong broker ng mga international CFDs trading securities na may numero ng lisensya`,
        des_3: `Bilang karagdagan, ang IUX Markets Limited ay nakarehistro sa National Futures Association (NFA) trading regulator, na nangangasiwa sa mga derivatives at futures broker,`,
      },
      section_1: {
        title_1: `Company History`,
        description_1: `IUX Markets was established  in 2016 as a provider of online CFDs trading services. Our client’s trading journey is very important to us, and as such we are always committed in refining our technology, tailored services and client education. For over a decade, as the industry and clients’ expectations keep evolving, we have positioned ourselves firmly as a trusted and leading  regulated broker.`,
        title_2: `Our Services`,
        description_2: `IUX Markets currently offers a spread-based and a commission-based trading account. We have more than 350 tradeable CFDs instruments including CFDs, Shares, Indices and Commodities. Widely recognised as the first MT4 broker in United Kingdom, we have since added MT4,mobile trading and a web-based platform to our suite of trading platforms.`,
        title_3: `Our Vision`,
        description_3: `We strive to be the first choice for trading CFDs for aspiring and experienced traders. We strive to continuously provide the best trading experience to our clients through reliable customer service, transparent pricing, low-latency trade execution and platform stability.`,
        description_4: `We are committed to creating a dynamic
                    environment that equips traders with all the necessary tools
                    for their trading experience with the utmost respect for
                    them.`,
        title_5: `Our Strategy`,
        description_5: `At IUXMARKETS we evolve with the times. We aim to continuously refine our services to cater to the needs of traders in this highly dynamic industry.`,
      },
      section_2: {
        title: `Our Values`,
        title_1: `Client-first approach`,
        title_2: `Integrity and Compliance`,
        title_3: `Innovation`,
        description_1: `We strive to be the first choice for trading CFDs for aspiring and experienced traders. We strive to continuously provide the best trading experience to our clients through reliable customer service, transparent pricing, low-latency trade execution and platform stability.`,
        description_2: `We endeavour to provide clients with transparent, secure and reliable services. IUX Markets is licensed by the St-Vincent CFDs Broker License `,
        description_3: `IUX Markets is dedicated to ensuring fast execution speed, quality trading platforms and secure transactions as a minimum standard for your trading experience.`,
      },
      section_3: {
        title: `Regulation`,
        description: `IUX Markets is regulated by the St-Vincent CFDs Broker License  and is a holder of an Investment Dealer (Discount Broker)`,
        sub_head_title_1: `Locations`,
        title_1: `United Kingdom`,
        title_2: ``,
        title_3: `Singapore`,
        description_1: `6-8 Revenge Road , Suite 2096 United Kingdom ME5 8UD Chatham, UK support@iuxmarket.com`,
        description_2: `P.B. 1257 Bonovo Road, Fomboni, Comoros, KM. `,
        description_3: `30 Paya Lebar Road, #01-37, Paya Lebar Square, Singapore 409051 support@iuxmarkets.com`,
      },
    },
  },
  ja: {
    aboutMeTitle: `IUX市場は、取引のレベルを高レベルのセキュリティに引き上げ始めました。 CFDS市場で世界最高のテクノロジーを備えたSwift実行。 取引に関する多くの問題を観察し、それらを修正するための行動を取っています。 顧客が取引システムにアクセスし、さまざまな取引を迅速かつ安全に行えるようにするため。 また、迅速かつ効率的に変動する金融市場の世界の重要性を理解し、時間を費やしていることを常に大切にしています。 私たちが下すすべての決定は、当社の専門家を含むお客様とビジネスパートナーが賢明に時間を費やすことを保証することです。 知識は力であり、トレーダーが最高の投資結果を得るように奨励することが私たちの欲求であると信じています。`,
    aboutMeIcon: {
      title_1: `世界クラスの安全基準`,
      description_1: `暗号化と24時間365日の監視により、データを安全に保ちます。`,
      title_2: `高速トランザクションが私たちの優先事項です。 \ n`,
      description_2: `私たちはトレーダーの経験を本当に理解しているため、すべてをシンプルにしています。`,
      title_3: `高速実行`,
      description_3: `クライアントに最高の取引体験をしてほしい。 このレベルの速度では、機会を見逃すことはありません。`,
      title_4: `私たちは世界中の銀行と提携しています。\ n`,
      description_4: `私たちは国内および外国の銀行と協力しています。 可能な限りリスクを最小限に抑えるために、預金資金からボーナスクレジットを受け取ることができます。`,
    },
    accept_policy: `利用規約を受け入れます`,
    policy_dashboard_1: `親愛なる顧客、\ n \ n thisは株にのみ影響を与えます。 株式（CFD）を取引する場合、次の更新に注意してください。\ n \ ntrading市場の開く前に保留中の注文を設定することは不可能です。\ n \ n注文は無効またはキャンセルされます。 結果として、グループ金融商品はすべての株（CFD）をカバーします。`,
    accountType: {
      standard: `最も低いスプレッドのトップアカウントは、あらゆるレベルの投資家のためのあらゆる種類の取引に適した委員会なし、預金および引き出し料金なし`,
      list: {
        list_1: `0.2ピップから広がります`,
        list_2: `最大レバレッジ1：3000`,
        list_3: `手数料なし`,
        list_4: `最低預金10 USD`,
      },
      cent: `あらゆる種類の取引に適した投資ユニットが少ない初心者投資家向けのアカウント`,
      list_cent: {
        list_1: `0.2ピップから広がります`,
        list_2: `最大レバレッジ1：3000`,
        list_3: `手数料なし`,
        list_4: `最低預金10 USD`,
      },
      standard_bonus: `長期取引に適した35％ボーナスアカウント。 料金、預金、引き出し料はありません`,
      list_bonus: {
        list_1: `0.5ピップから広がります`,
        list_2: `最大レバレッジ1：1000`,
        list_3: `35％のデポジットボーナス`,
        list_4: `最低預金10 USD`,
      },
      standard_ecn: `VIP Investorアカウントのスプレッドスプレッドは0.0ピップから始まり、手数料はわずか3.5ドルで、預金と引き出し料はありません`,
      list_ecn: {
        list_1: `0.0ピップから広がります`,
        list_2: `最大レバレッジ1：3000`,
        list_3: `3.5ドルの手数料`,
        list_4: `最低堆積物200米ドル`,
      },
      standard_raw: `VIP Investorアカウントのスプレッドスプレッドは0.0ピップから始まり、手数料はわずか7ドルで、預金と引き出し料はありません`,
      list_raw: {
        list_1: `0.0ピップから広がります`,
        list_2: `最大レバレッジ1：3000`,
        list_3: `7ドルの手数料`,
        list_4: `最低堆積物200米ドル`,
      },
      standard_pro: `最も低いスプレッドの優れた充填と滑りの減少との取引。 レクオットは、速い移動市場で発生する可能性があります`,
      list_pro: {
        list_1: `0.1ピップを広げます`,
        list_2: `手数料なし`,
        list_3: `最低堆積物1000米ドル`,
        list_4: `0.1最小ロットサイズ`,
      },
      btn: {
        real: `実際の取引口座を開きます`,
        demo: `デモアカウントでの取引`,
      },
    },

    aboutPage: {
      why_become: `なぜ私たちのパートナーになるのですか？`,
      Our_in_house: `当社の社内スポットアグリゲーターと高度な注文マッチングテクノロジーは、トレーダーが緊密なスプレッドと競争力のある価格設定から利益を得ることができるように、デスクの介入なしで、深い流動性プールと超高速取引実行へのアクセスをトレーダーに提供します。`,
      our_history: {
        header: `私たちの歴史`,
        detail: `私たちの設立以来、IUX市場は170か国以上の小売および機関のクライアントにサービスを提供するために成功裏に拡大してきましたが、私たちはまだ成長しています。`,
        title_2: `IUX Markets Limited。 これは、証券委員会による監督の対象となります。 金融サービス局は、金融サービスの事業と番号T2023172登録住所を許可しています：P.B。 1257 Bonovo Road、Fomboni、Comoros、Km。 グレナジンとIUX Markets Limited。 また、CFTCによって登録先物協会として指定された米国から国立先物協会（NFA）に登録されています。 NFAは、デリバティブ市場の完全性を保護し、投資家を保護し、メンバーが規制の責任を満たすように毎日努力しています。`,
      },
      box_1: {
        des_1: `IUX Marketsは、株式、スポットインデックス、先物、スポットメタル、スポットエネルギーの取引を提供しています。 当社は、デスクの介入なしで一流の流動性と高度な貿易の実行へのアクセスをクライアントに提供します。`,
      },
      box_2: {
        des_1: `IUX Markets Limitedは、証券委員会による監督の対象となります。 セントビンセントとグレナジンの金融サービス局は、金融サービスと数のビジネスを許可しました`,
        des_2: `ビーチモントビジネスセンター、321、キングスタウン、セントビンセント、グレナジンアンドIUXマーケットリミテッドに登録されています。`,
        des_3: `IUX Markets Limitedは、デリバティブおよび先物ブローカーを監督するNational Futures Association（NFA）Trading Regulatorに登録されています。`,
      },
      section_1: {
        title_1: `会社の歴史`,
        description_1: `IUX Marketsは、2016年にオンラインCFDS取引サービスのプロバイダーとして設立されました。 私たちのクライアントの取引の旅は私たちにとって非常に重要であり、そのため、私たちは常にテクノロジー、テーラードサービス、クライアント教育の洗練にコミットしています。 10年以上にわたり、業界とクライアントの期待が進化し続けるにつれて、私たちは信頼され、主要な規制されたブローカーとして自分自身をしっかりと位置づけてきました。`,
        title_2: `私たちのサービス`,
        description_2: `IUX Marketsは現在、スプレッドベースと手数料ベースの取引口座を提供しています。 CFD、株式、インデックス、商品を含む350を超える取引可能なCFDS機器があります。 英国で最初のMT4ブローカーとして広く認識されているため、MT4、モバイル取引、Webベースのプラットフォームを一連の取引プラットフォームに追加しました。`,
        title_3: `私たちのビジョン`,
        description_3: `私たちは、意欲的で経験豊富なトレーダーのためにCFDを取引するための最初の選択肢になるよう努めています。 私たちは、信頼できる顧客サービス、透明な価格設定、低遅延取引の実行、プラットフォームの安定性を通じて、クライアントに最高の取引体験を継続的に提供するよう努めています。`,
        description_4: `We are co私たちはダイナミクスを作成することに取り組んでいます 
                     トレーダーに必要なすべてのツールを装備する環境 
                     最大限の敬意を持った取引経験のために 
                     彼ら。`,
        title_5: `私たちの戦略`,
        description_5: `iuxmarketsでは、時代とともに進化します。 私たちは、この非常にダイナミックな業界のトレーダーのニーズに応えるために、サービスを継続的に改良することを目指しています。`,
      },
      section_2: {
        title: `私達の価値`,
        title_1: `クライアントファーストアプローチ`,
        title_2: `整合性とコンプライアンス`,
        title_3: `革新`,
        description_1: `私たちは、意欲的で経験豊富なトレーダーのためにCFDを取引するための最初の選択肢になるよう努めています。 私たちは、信頼できる顧客サービス、透明な価格設定、低遅延取引の実行、プラットフォームの安定性を通じて、クライアントに最高の取引体験を継続的に提供するよう努めています。`,
        description_2: `私たちは、クライアントに透明で安全で信頼できるサービスを提供するよう努めています。 IUX Marketsは、St-Vincent CFDSブローカーライセンスによってライセンスされています`,
        description_3: `IUX Marketsは、取引体験の最低基準として、迅速な実行速度、質の高い取引プラットフォーム、および安全なトランザクションを確保することに専念しています。`,
      },
      section_3: {
        title: `規制`,
        description: `IUX Marketsは、ST-Vincent CFDSブローカーライセンスによって規制されており、投資ディーラー（ディスカウントブローカー）の所有者です`,
        sub_head_title_1: `場所`,
        title_1: `イギリス`,
        title_2: ``,
        title_3: `Singapore`,
        description_1: `6-8 Revenge Road , Suite 2096 United Kingdom \nME5 8UD Chatham, UK support@iuxmarket.com`,
        description_2: `P.B. 1257 Bonovo Road, Fomboni, Comoros, KM. `,
        description_3: `30 Paya Lebar Road, #01-37, Paya Lebar Square, \nSingapore 409051 `,
      },
    },
  },
  es: {
    aboutMeTitle:
      "IUX Markets comenzó a elevar el nivel de trading a un alto nivel de seguridad. Ejecuciones rápidas con la mejor tecnología del mundo en el mercado de CFDs. Hemos observado numerosos problemas con el trading y hemos tomado medidas para solucionarlos; para permitir a los clientes acceder al sistema de trading y realizar diversas transacciones de manera rápida y segura. También valoramos las Commodities en todo momento dedicando tiempo y entendiendo la importancia del mundo de los mercados financieros que fluctúan rápida y eficientemente. Cada decisión que tomamos es para asegurar que nuestros clientes y socios comerciales, incluyendo nuestro equipo de expertos, usen su tiempo de manera sabia. Creemos que el conocimiento es poder y fomentar a los traders a obtener los mejores resultados de inversión es nuestro deseo.",
    aboutMeIcon: {
      title_1: "Estándares de Seguridad de Clase Mundial",
      description_1:
        "Mantenemos tus datos seguros con cifrado y vigilancia 24/7.",
      title_2: "Las transacciones rápidas son nuestra prioridad.",
      description_2:
        "Realmente entendemos la experiencia de los traders, por eso hacemos todo sencillo.",
      title_3: "Ejecución de Alta Velocidad",
      description_3:
        "Queremos que nuestros clientes tengan la mejor experiencia de trading. Con este nivel de velocidad, no perderás la oportunidad.",
      title_4: "Nos asociamos con bancos de todo el mundo.",
      description_4:
        "Cooperamos con bancos nacionales y extranjeros. Permitiéndote recibir créditos de bonificación al depositar fondos para minimizar el riesgo lo más posible.",
    },
    accept_policy: "Acepta los términos y condiciones",
    policy_dashboard_1:
      "Estimados Clientes,\n\nEsto solo afecta a las acciones. Por favor, tengan en cuenta las siguientes actualizaciones si operan con acciones (CFDs).\n\nNo es posible operar configurando órdenes pendientes antes de que el mercado abra.\n\nLa orden será invalidada o cancelada. Solo una vez que el mercado abra se pueden colocar órdenes activas. Como resultado, los instrumentos financieros del grupo cubren todas las acciones (CFDs).\n\n¡Por favor, consideren esta información y hagan los ajustes necesarios a su estrategia de trading con antelación!\n\nSaludos cordiales, IUX Markets Limited.",
    accountType: {
      standard:
        "Las mejores cuentas con el spread más bajo Sin comisiones Adecuadas para todo tipo de trading Para inversores de todos los niveles, Sin tarifas de depósito y retiro",
      list: {
        list_1: "Spread desde 0.2 PIPs",
        list_2: "Máximo apalancamiento 1:3000",
        list_3: "Sin comisión",
        list_4: "Depósito mínimo 10 USD",
      },
      cent: "Una cuenta para inversores principiantes con menos unidades de inversión Adecuada para todo tipo de trading",
      list_cent: {
        list_1: "Spread desde 0.2 PIPs",
        list_2: "Máximo apalancamiento 1:3000",
        list_3: "Sin comisión",
        list_4: "Depósito mínimo 10 USD",
      },
      standard_bonus:
        "Cuenta de bonificación del 35% adecuada para el trading a largo plazo. Sin tarifas, Sin tarifas de depósito y retiro",
      list_bonus: {
        list_1: "Spread desde 0.5 PIPs",
        list_2: "Máximo apalancamiento 1:1000",
        list_3: "35% Bonificación de Depósito",
        list_4: "Depósito mínimo 10 USD",
      },
      standard_ecn:
        "Cuenta VIP para inversores con spread desde 0.0 PIPs, la comisión es de solo $ 3.5, Sin tarifas de depósito y retiro",
      list_ecn: {
        list_1: "Spread desde 0.0 PIPs",
        list_2: "Máximo apalancamiento 1:3000",
        list_3: "$3.5 Comisión",
        list_4: "Depósito mínimo 200 USD",
      },
      standard_raw:
        "Cuenta VIP para inversores con spread desde 0.0 PIPs, la comisión es de solo $ 7, Sin tarifas de depósito y retiro",
      list_raw: {
        list_1: "Spread desde 0.0 PIPs",
        list_2: "Máximo apalancamiento 1:3000",
        list_3: "$6 Comisión",
        list_4: "Depósito mínimo 200 USD",
      },
      standard_pro:
        "Opera con el spread más bajo Excelente llenado y deslizamiento reducido. Puede haber recotizaciones en mercados de rápido movimiento",
      list_pro: {
        list_1: "Spread 0.1 PIPs",
        list_2: "Sin comisión",
        list_3: "Depósito mínimo 1000 USD",
        list_4: "0.1 Tamaño de Lote Mínimo",
      },
      btn: {
        real: "Abrir una cuenta de trading real",
        demo: "Operar en una cuenta demo",
      },
    },
    aboutPage: {
      why_become: "¿POR QUÉ CONVERTIRSE EN NUESTRO SOCIO?",
      Our_in_house:
        "Nuestro agregador de puntos interno y tecnología avanzada de coincidencia de órdenes brindan a nuestros traders acceso a un grupo de liquidez profundo y ejecución de operaciones ultrarrápida sin intervención de mesa de operaciones, para que los traders puedan beneficiarse de un spread ajustado y precios competitivos.",
      our_history: {
        header: "NUESTRA HISTORIA",
        detail:
          "Desde nuestra creación, IUX Markets ha logrado expandirse con éxito para servir a clientes minoristas e institucionales en más de 170 países, y seguimos creciendo.",
        title_2:
          "IUX Markets Limited. Está supervisado por la Comisión de Valores. La Autoridad de Servicios Financieros ha autorizado el negocio de servicios financieros con el número T2023172 Dirección Registrada: P.B. 1257 Bonovo Road, Fomboni, Comoras, KM. y las Granadinas, e IUX Markets Limited. también está registrado en la Asociación Nacional de Futuros (NFA) de Estados Unidos, designada por la CFTC como una asociación de futuros registrada. NFA se esfuerza todos los días para salvaguardar la integridad de los mercados de derivados, proteger a los inversores y asegurar que los miembros cumplan con sus responsabilidades regulatorias.",
      },
      box_1: {
        des_1:
          "IUX Markets ofrece trading en Acciones, Índices Spot, Futuros, Metales Spot y Energías Spot. Brindamos a nuestros clientes acceso a liquidez de primer nivel y ejecución avanzada de operaciones sin intervención de mesa de operaciones.",
      },
      box_2: {
        des_1:
          "IUX Markets Limited, que está supervisado por la Comisión de Valores. La Autoridad de Servicios Financieros en San Vicente y las Granadinas ha autorizado el negocio de servicios financieros con el número",
        des_2:
          "registrado en Beachmont Business Centre, 321, Kingstown, San Vicente y las Granadinas",
        des_3:
          "IUX Markets Limited está registrado en la Asociación Nacional de Futuros (NFA), regulador de trading, que supervisa a los brokers de derivados y futuros,",
      },
      section_1: {
        title_1: "Historia de la Compañía",
        description_1:
          "IUX Markets se estableció en 2016 como un proveedor de servicios de trading de CFDs en línea. El viaje de trading de nuestros clientes es muy importante para nosotros, y como tal, siempre estamos comprometidos en refinar nuestra tecnología, servicios personalizados y educación del cliente. Durante más de una década, a medida que la industria y las expectativas de los clientes continúan evolucionando, nos hemos posicionado firmemente como un broker regulado y de confianza líder.",
        title_2: "Nuestros Servicios",
        description_2:
          "IUX Markets actualmente ofrece una cuenta de trading basada en spread y una cuenta de trading basada en comisiones. Tenemos más de 350 instrumentos CFDs comerciables, incluyendo CFDs, Acciones, Índices y Commodities. Ampliamente reconocido como el primer broker de MT4 en el Reino Unido, desde entonces hemos añadido MT4, trading móvil y una plataforma basada en web a nuestra suite de plataformas de trading.",
        title_3: "Nuestra Visión",
        description_3:
          "Nos esforzamos por ser la primera opción para operar CFDs para traders aspirantes y experimentados. Nos esforzamos por proporcionar continuamente la mejor experiencia de trading a nuestros clientes a través de un servicio al cliente confiable, precios transparentes, ejecución de operaciones de baja latencia y estabilidad de la plataforma.",
        description_4:
          "Nos comprometemos a crear un entorno dinámico que equipe a los traders con todas las herramientas necesarias para su experiencia de trading con el máximo respeto hacia ellos.",
        title_5: "Nuestra Estrategia",
        description_5:
          "En IUXMARKETS evolucionamos con los tiempos. Apuntamos a refinar continuamente nuestros servicios para satisfacer las necesidades de los traders en esta industria altamente dinámica.",
      },
      section_2: {
        title: "Nuestros Valores",
        title_1: "Enfoque centrado en el cliente",
        title_2: "Integridad y Cumplimiento",
        title_3: "Innovación",
        description_1:
          "Nos esforzamos por ser la primera opción para operar CFDs para traders aspirantes y experimentados. Nos esforzamos por proporcionar continuamente la mejor experiencia de trading a nuestros clientes a través de un servicio al cliente confiable, precios transparentes, ejecución de operaciones de baja latencia y estabilidad de la plataforma.",
        description_2:
          "Nos esforzamos por proporcionar a los clientes servicios transparentes, seguros y confiables. IUX Markets tiene licencia de la Licencia de Broker de CFDs de San Vicente",
        description_3:
          "IUX Markets se dedica a garantizar la velocidad de ejecución rápida, plataformas de trading de calidad y transacciones seguras como un estándar mínimo para tu experiencia de trading.",
      },
      section_3: {
        title: "Regulación",
        description:
          "IUX Markets está regulado por la Licencia de Broker de CFDs de San Vicente y es titular de una licencia de Corredor de Inversiones (Corredor de Descuento)",
        sub_head_title_1: "Ubicaciones",
        title_1: "Reino Unido",
        title_2: "",
        title_3: "Singapur",
        description_1:
          "6-8 Revenge Road, Suite 2096, Reino Unido \nME5 8UD Chatham, UK support@iuxmarket.com",
        description_2: "P.B. 1257 Bonovo Road, Fomboni, Comoras, KM.",
        description_3:
          "30 Paya Lebar Road, #01-37, Paya Lebar Square, \nSingapur 409051",
      },
    },
  },
};
